'use strict';

/**
 * @ngdoc overview
 * @name com.amfam.services
 * @description
 * # com.amfam.services
 *
 * Amfam services module
 */
angular.module('com.amfam.services', []);

//------//
// Init //
//------//

/**
 * @ngdoc overview
 * @name tierConfig
 * @description
 *
 * 1. Load Tier dependent configuration
 * 2. Redirect to router for missing query params
 * 3. Load afiNgServicesApp app
 *
 */

(function () {
  var injector = angular.injector(["ng"]),
    $http = injector.get("$http"),
    urlParams = {},
    initialRoute = window.location.hash.substring(1);

  // Search url for all parameters and store them key/val matched into an object
  window.location.search.substr(1).split("&").forEach(function(item) {
    var param = item.split("="),
      paramKey = param[0],
      paramVal = param[1] && decodeURIComponent(param[1]);
    urlParams[paramKey] = paramVal;
  });

  //load tier config
  $http.get('config.json')
    .then(function (response) {
      // is this a branded experience?
      var hasBrand = (typeof urlParams.expid === 'undefined') ? false : true;

      // create the tierConfig module
      angular.module('tierConfig', [])
        .constant('TierUtils', {
          brand: {
            connectClaimNo: '1-866-922-4059',
            connectCusCareEmail: 'contactus@midvaleinsurance.com',
            connectCusCareHoursWday: '8am to 9pm EST M-F',
            connectCusCareNo: '1-866-328-9577',
            policyTypesEnabled: 'Auto|Condo|Home|Renters',
            retrieveQuoteEnabled: false
          },
          brandRetrieved: false,
          config: response.data,
          hasBrand: hasBrand,
          hash: initialRoute,
          params: urlParams
        });
      //bootstrap our main module afiNgServicesApp
      angular.bootstrap(document.documentElement, ['afiNgServicesApp']);
    });
})();

/**
 * @ngdoc overview
 * @name afiNgServicesApp
 * @description
 * # afiNgServicesApp
 *
 * Main module of the application.
 */
angular
  .module('afiNgServicesApp', [
    'com.amfam.services',
    'tierConfig',
    'ngAnimate',
    'ngCookies',
    'ngMessages',
    'ngResource',
    'ngSanitize',
    'ngTouch',
    'mgcrea.ngStrap',
    'ui.router',
    'matchmedia-ng',
    'angular-inview',
    'ui.bootstrap',
    'ui.mask',
    'angular-momentjs',
    'lodash'
  ])
  .config(
    function ($stateProvider, $urlRouterProvider) {

      //
      // Load default view
      $urlRouterProvider.when("/", "/quote-retrieve");

      // Load default view
      $urlRouterProvider.when("", ['TierUtils', '$location', function (TierUtils, $location) {
        var initialRoute = TierUtils.params.i;
        if (initialRoute) {
          $location.search("i", null);
          return initialRoute;
        }
        return "/";
      }]);
      $urlRouterProvider.when("/autoland", ['TierUtils', '$location', function (TierUtils, $location) {
        var initialRoute = TierUtils.params.i;
        if (initialRoute && initialRoute !== "autoland") {
          $location.search("i", null);
          return initialRoute;
        }
        return "/";
      }]);
      $urlRouterProvider.when("/homeland", ['TierUtils', '$location', function (TierUtils, $location) {
        var initialRoute = TierUtils.params.i;
        if (initialRoute && initialRoute !== "homeland") {
          $location.search("i", null);
          return initialRoute;
        }
        return "/";
      }]);
      $urlRouterProvider.otherwise("/quote-retrieve");

      //----------------
      // BEGIN STATES
      //----------------
      $stateProvider
        .state('main', {
          url: '/',
          controller: 'MainCtrl',
          controllerAs: 'main',
          templateUrl: 'views/main.html',
          data: {
            hideBanner: false,
            topNav: 'login',
            secNav: 'retrieve',
            mobileNav: 'login',
            mobileMenu: true
          }
        })

        //-------
        // LOGIN
        //-------
        .state('main.login', {
          name: 'login',
          url: 'login',
          parent: 'main',
          controller: 'MainCtrl',
          controllerAs: 'main',
          views: {
            'desktop': {
              templateUrl: 'views/quote-retrieve.html',
              data: {
                hideBanner: false,
                menuItem: 'retrieve'
              }
            },
            'mobile-login': {
              templateUrl: 'views/login-form.html',
              data: {
                hideBanner: false,
                menuItem: 'login'
              }
            }
          }
        })

        //-------------------
        // QUOTE RETRIEVAL
        //-------------------
        .state('main.quote-retrieve', {
          name: 'quote-retrieve',
          url: 'quote-retrieve',
          parent: 'main',
          views: {
            'desktop': {
              controller: 'QuoteRetrieveCtrl',
              controllerAs: 'quoteretrieve',
              templateUrl: 'views/quote-retrieve.html',
              data: {
                hideBanner: false,
                menuItem: 'retrieve'
              }
            },
            'mobile-quote': {
              controller: 'QuoteRetrieveCtrl',
              controllerAs: 'quoteretrieve',
              templateUrl: 'views/quote-retrieve.html',
              data: {
                hideBanner: false,
                menuItem: 'retrieve'
              }
            }
          }
        })

        // Retrieve auto quote
        //
        .state('main.quote-retrieve.auto', {
          name: 'quote-retrieve.auto',
          url: '^/auto-quote-retrieve',
          parent: 'main',
          views: {
            'desktop': {
              controller: 'AutoQuoteRetrieveCtrl',
              controllerAs: 'quoteretrieveauto',
              templateUrl: 'views/auto-quote-retrieve.html',
              data: {
                hideBanner: false,
                menuItem: 'retrieve'
              }
            },
            'mobile-quote': {
              controller: 'AutoQuoteRetrieveCtrl',
              controllerAs: 'quoteretrieveauto',
              templateUrl: 'views/auto-quote-retrieve.html',
              data: {
                hideBanner: false,
                menuItem: 'retrieve'
              }
            }
          }
        })

        // Retrieve commercial quote
        //
        .state('main.quote-retrieve.commercial', {
          name: 'quote-retrieve.commercial',
          url: '^/commercial-quote-retrieve',
          parent: 'main',
          views: {
            'desktop': {
              controller: 'HomeQuoteRetrieveCtrl',
              controllerAs: 'quoteretrievecommercial',
              templateUrl: 'views/commercial-quote-retrieve.html',
              data: {
                hideBanner: false,
                menuItem: 'retrieve'
              }
            },
            'mobile-quote': {
              controller: 'HomeQuoteRetrieveCtrl',
              controllerAs: 'quoteretrievecommercial',
              templateUrl: 'views/commercial-quote-retrieve.html',
              data: {
                hideBanner: false,
                menuItem: 'retrieve'
              }
            }
          }
        })

        // Retrieve home quote
        //
        .state('main.quote-retrieve.home', {
          name: 'quote-retrieve.home',
          url: '^/home-quote-retrieve',
          parent: 'main',
          data: {
            product: 'homesales'
          },
          views: {
            'desktop': {
              controller: 'HomeQuoteRetrieveCtrl',
              controllerAs: 'quoteretrievehome',
              templateUrl: 'views/home-quote-retrieve.html',
              data: {
                hideBanner: false,
                menuItem: 'retrieve'
              }
            },
            'mobile-quote': {
              controller: 'HomeQuoteRetrieveCtrl',
              controllerAs: 'quoteretrievehome',
              templateUrl: 'views/home-quote-retrieve.html',
              data: {
                hideBanner: false,
                menuItem: 'retrieve'
              }
            }
          }
        })

        // Retrieve condo quote
        //
        .state('main.quote-retrieve.condo', {
          name: 'quote-retrieve.condo',
          url: '^/condo-quote-retrieve',
          parent: 'main',
          data: {
            product: 'condosales'
          },
          views: {
            'desktop': {
              controller: 'HomeQuoteRetrieveCtrl',
              controllerAs: 'quoteretrievecondo',
              templateUrl: 'views/condo-quote-retrieve.html',
              data: {
                hideBanner: false,
                menuItem: 'retrieve'
              }
            },
            'mobile-quote': {
              controller: 'HomeQuoteRetrieveCtrl',
              controllerAs: 'quoteretrievecondo',
              templateUrl: 'views/condo-quote-retrieve.html',
              data: {
                hideBanner: false,
                menuItem: 'retrieve'
              }
            }
          }
        })

        // Retrieve renters quote
        //
        .state('main.quote-retrieve.renters', {
          name: 'quote-retrieve.renters',
          url: 'renters-quote-retrieve',
          parent: 'main',
          data: {
            product: 'rentsales'
          },
          views: {
            'desktop': {
              controller: 'HomeQuoteRetrieveCtrl',
              controllerAs: 'quoteretrieverenters',
              templateUrl: 'views/renters-quote-retrieve.html',
              data: {
                hideBanner: false,
                menuItem: 'retrieve'
              }
            },
            'mobile-quote': {
              controller: 'HomeQuoteRetrieveCtrl',
              controllerAs: 'quoteretrieverenters',
              templateUrl: 'views/renters-quote-retrieve.html',
              data: {
                hideBanner: false,
                menuItem: 'retrieve'
              }
            }
          }
        })


        //---------------
        // REPORT CLAIM
        //---------------
        .state('main.report-claim', {
          name: 'report-claim',
          url: 'report-claim',
          parent: 'main',
          views: {
            'desktop': {
              controller: 'ReportClaimCtrl',
              controllerAs: 'rc',
              templateUrl: 'views/report-claim.html',
              data: {
                hideBanner: false,
                menuItem: 'claim'
              }
            },
            'mobile-claim': {
              controller: 'ReportClaimCtrl',
              controllerAs: 'rc',
              templateUrl: 'views/report-claim.html',
              data: {
                hideBanner: false,
                menuItem: 'claim'
              }
            }
          }
        })

        // Report auto claim
        //
        .state('main.report-claim.auto', {
          name: 'report-claim.auto',
          url: 'auto-claim',
          parent: 'main',
          views: {
            'desktop': {
              controller: 'AutoClaimCtrl',
              controllerAs: 'claim',
              templateUrl: 'views/auto-claim-redirect.html',
              data: {
                hideBanner: false,
                menuItem: 'claim'
              }
            },
            'mobile-claim': {
              controller: 'AutoClaimCtrl',
              controllerAs: 'claim',
              templateUrl: 'views/auto-claim-redirect.html',
              data: {
                hideBanner: false,
                menuItem: 'claim'
              }
            }
          }
        })

        // Report home claim
        //
        .state('main.report-claim.home', {
          name: 'report-claim.home',
          url: 'home-claim',
          parent: 'main',
          views: {
            'desktop': {
              controller: 'HomeClaimCtrl',
              controllerAs: 'home',
              templateUrl: 'views/home-claim.html',
              data: {
                hideBanner: false,
                menuItem: 'claim'
              }
            },
            'mobile-claim': {
              controller: 'HomeClaimCtrl',
              controllerAs: 'home',
              templateUrl: 'views/home-claim.html',
              data: {
                hideBanner: false,
                menuItem: 'claim'
              }
            }
          }
        })

        // Report Condo claim
        //
        .state('main.report-claim.condo', {
          name: 'report-claim.condo',
          url: 'condo-claim',
          parent: 'main',
          views: {
            'desktop': {
              controller: 'CondoClaimCtrl',
              controllerAs: 'condo',
              templateUrl: 'views/condo-claim.html',
              data: {
                hideBanner: false,
                menuItem: 'claim'
              }
            },
            'mobile-claim': {
              controller: 'CondoClaimCtrl',
              controllerAs: 'condo',
              templateUrl: 'views/condo-claim.html',
              data: {
                hideBanner: false,
                menuItem: 'claim'
              }
            }
          }
        })

        // Report renters claim
        //
        .state('main.report-claim.renters', {
          name: 'report-claim.renters',
          url: 'renters-claim',
          parent: 'main',
          views: {
            'desktop': {
              controller: 'RentersClaimCtrl',
              controllerAs: 'renters',
              templateUrl: 'views/renters-claim.html',
              data: {
                hideBanner: false,
                menuItem: 'claim'
              }
            },
            'mobile-claim': {
              controller: 'RentersClaimCtrl',
              controllerAs: 'renters',
              templateUrl: 'views/renters-claim.html',
              data: {
                hideBanner: false,
                menuItem: 'claim'
              }
            }
          }
        })

        //-----------
        // CONTACT
        //-----------
        .state('main.contact', {
          name: 'contact',
          url: 'contact',
          parent: 'main',
          views: {
            'desktop': {
              controller: 'MainCtrl',
              controllerAs: 'main',
              templateUrl: 'views/contact.html',
              data: {
                hideBanner: false,
                menuItem: 'claim'
              }
            },
            'mobile-contact': {
              controller: 'MainCtrl',
              controllerAs: 'main',
              templateUrl: 'views/contact.html',
              data: {
                hideBanner: false,
                menuItem: 'claim'
              }
            }
          }
        })


        //
        // Claim Confirmation
        .state('confirm', {
          url: "/confirm",
          name: 'confirm',
          abstract: true,
          templateUrl: 'views/confirm.html'
        })
        .state('confirm.auto-claim', {
          name: 'auto-claim-confirm',
          url: '^/auto-claim-confirm',
          parent: 'confirm',
          controller: 'AutoClaimCtrl',
          controllerAs: 'claim',
          templateUrl: 'views/auto-claim-confirm.html',
          params: {
            confirm: {
              value: '',
              squash: true
            }
          },
          data: {
            branded: false
          }
        })


        //----------------
        // STATE TESTING - TODO: DELETE BEFORE GO LIVE
        //----------------
        .state('user-info', {
          url: '/user-info',
          name: 'user-info',
          abstract: true,
          templateUrl: 'views/user-info.html',
          data: {
            branded: false
          }
        })

        .state('user-info.test', {
          name: 'inter-test',
          url: '^/test-states',
          parent: 'user-info',
        controller: 'AutoClaimCtrl',
        controllerAs: 'claim',
          templateUrl: 'views/test-states.html',
          data: {
            branded: false
          }
        });
    }
  )

  .config(
    function (TagManagerProvider) {
      TagManagerProvider.setAccount('GTM-NLHPCJ');
      TagManagerProvider.setAppName('auto-services');
    }
  )

  .config(
    function (AfEncryptProvider, TierUtils) {
      AfEncryptProvider.setKey(TierUtils.config.partnerKey);
      AfEncryptProvider.setIv(TierUtils.config.partnerIv);
    }
  )

  .run(function ($rootScope, $state, $stateParams, BannerService, TierUtils, TagManager) {
    TagManager.setSessionId(TierUtils.params.msid);
    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      TagManager.trackPage(toState.name);
    });

    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;
    $rootScope.$on("$stateChangeSuccess",
      function (event, toState) {
        if (toState.data.hideBanner) {
          BannerService.hideBanner = true;
        }
      });
  })

  .filter('trusted', ['$sce', function ($sce) {
    return function (url) {
      return $sce.trustAsResourceUrl(url);
    };
  }]);

/**
 * @ngdoc function
 * @name afiNgServicesApp.service:UtilityService
 * @description
 * # UtilityService
 * Service for utility functions
 */
(function() {
  'use strict';

  angular
    .module('afiNgServicesApp')
    .factory('UtilityService', UtilityService);

  UtilityService.$inject = ['$window'];

  function UtilityService($window) {
    var service = {
      goToUrl: goToUrl,
      dateSubmitFormat: dateSubmitFormat,
      dateSubmitClaimFormat: dateSubmitClaimFormat,
      timeSubmitFormat: timeSubmitFormat
    };
    return service;

    function goToUrl(url) {
      $window.location.href = url;
    }

    // TODO Scrap all of this and use momentjs
    function dateSubmitFormat(dateString) {
      var dateObj = new Date(dateString);
      var month = zeroPad((parseInt(dateObj.getMonth())+ 1)).toString(),
        day = zeroPad(parseInt(dateObj.getDate())).toString(),
        year = dateObj.getFullYear().toString();
      return year + "-" + month + "-" + day;
    }

    function dateSubmitClaimFormat(dateObj) {
      var month = zeroPad((parseInt(dateObj.getMonth())+ 1)).toString(),
        day = zeroPad(parseInt(dateObj.getDate())).toString(),
        year = dateObj.getFullYear().toString();
      return month + "/" + day + "/" + year;
    }

    function timeSubmitFormat(dateObj) {
      var mer,
      formattedTime = [],
      h = dateObj.getHours(),
      m = dateObj.getMinutes();

      if(h > 12) {
        mer = 'PM';
        h = (h - 12);

        if (h === 12) {
          mer = 'AM';
        }
      }
      else if(h < 12) {
        if(h < 10 && h !== 0) {
          h = '0' + h.toString();
        } else if (h === 0) {
          h = 12;
        } else {
          h.toString();
        }
        mer = 'AM';
      }
      else if(h === 12) {
        mer = 'PM';
      }

      if(+h!==parseInt(h)){
        h = h.toString;
      }
      m = ((m < 10) ? '0' + m.toString() : m.toString());
      formattedTime.hhmm = h + ":" + m;
      formattedTime.mer = mer;
      return formattedTime;
    }

    // Private
    function zeroPad(toPad) {
      return (toPad < 10) ? "0" + toPad : toPad;
    }
  }
})();

/**
 * @ngdoc function
 * @name afiNgServicesApp.service:OffCanvas
 * @description
 * # OffCanvas
 * Service for slide-in login form
 */
(function() {
  'use strict';

  angular
    .module('afiNgServicesApp')
    .factory('OffCanvas', OffCanvas);

  OffCanvas.$inject = ['NavService'];

  function OffCanvas(NavService) {
    return NavService.offCanvasMenu({
      controller: 'MainCtrl',
      controllerAs: 'main',
      templateUrl: 'views/login-slidein-form.html'
    });
  }

})();

/**
 * @ngdoc function
 * @name afiNgServicesApp.service:NavService
 * @description
 * # NavService
 * Service for navigation
 */
(function() {
  'use strict';

  angular
    .module('afiNgServicesApp')
    .factory('NavService', NavService);

  NavService.$inject = ['$compile', '$rootScope', '$controller', '$http', '$templateCache', '$q'];

  function NavService($compile, $rootScope, $controller, $http, $templateCache, $q) {
    var imp = {
      offCanvasMenu: offCanvasMenu
    };
    return imp;

    function offCanvasMenu(config) {

      var menu = {};
      menu.isOpened = false;

      var container = angular.element(config.container || document.body),
        containerClass = config.containerClass || 'is-off-canvas-opened',
        controller = config.controller || angular.noop,
        controllerAs = config.controllerAs,
        element = null,
        html, deferred, scope, ctrl;

      if ((+!!config.template) + (+!!config.templateUrl) !== 1) {
        throw new Error('You must specify either a `template` or a `templateUrl` to create an off-canvas navigation.');
      }

      if (config.template) {
        deferred = $q.defer();
        deferred.resolve(config.template);
        html = deferred.promise;
      } else {
        html = $http.get(config.templateUrl, {
          cache: $templateCache
        }).then(function(response) {
          return '<div ng-hide="main.viewProperty.device.phone" class="off-canvas__container">' + response.data + '</div>';
        });
      }

      html.then(function(html) {
        scope = $rootScope.$new();
        ctrl = $controller(controller, {$scope: scope});
        if (controllerAs) {
          scope[controllerAs] = ctrl;
        }
        element = angular.element(html);
        container.prepend(element);
        $compile(element)(scope);
      });

      menu.toggle = function() {
        menu.isOpened = !menu.isOpened;
        container.toggleClass(containerClass);
        $rootScope.$emit('navToggle', menu.isOpened);

      };

      menu.open = function() {
        if (!menu.isOpened) {
          menu.isOpened = true;
          container.toggleClass(containerClass, true);
          $rootScope.$emit('navToggle', menu.isOpened);
        }
      };

      menu.close = function() {
        if (menu.isOpened) {
          menu.isOpened = false;
          container.toggleClass(containerClass, false);
          $rootScope.$emit('navToggle', menu.isOpened);
        }
      };

      return menu;
    }
  }
})();

/**
 * @ngdoc function
 * @name afiNgServicesApp.service:ChatService
 * @description
 * # ChatService
 * Service for amfam chat API
 */
(function () {
  'use strict';

  angular
    .module('afiNgServicesApp')
    .factory('ChatService', ChatService);

  ChatService.$inject = ['TierUtils','$moment','_'];
  function ChatService(TierUtils,moment,_) {
    var chatUrl = TierUtils.config.chatUrl;
    var chatHours = TierUtils.config.chatHours;
    var chatStart = moment.utc().set({hour: chatHours.startHour, minute: chatHours.startMin, second: 0});
    if (moment.utc().hour() < chatHours.startHour - chatHours.offset) {
      chatStart.subtract(1, 'day');
    }
    var chatEnd = moment.utc(chatStart).add(chatHours.hoursLive, 'hours');

    var service = {
      chatWindow: null,
      isChatActive: isChatActive,
      connectToChat: connectToChat
    };
    return service;

    function connectToChat(form) { // Pop chat window
      var windowInfo = {};
      var formArray = [];

      // Get key / val pairs of object and create an array from them
      _.filter(form, function(key){
        if (key && key.$name !== undefined) {
          formArray[key.$name] = key.$modelValue;
        }
      });

      windowInfo.url = chatUrl + "?fname="+formArray.firstName+"&lname="+formArray.lastName+"&state="+formArray.state.code+"&subject=CL%20Chat%20AFC01&zipcode="+formArray.zipCode;
      windowInfo.options = "toolbar=no,menubar=no,location=no,width=700,height=600";
      service.chatWindow = window.open(windowInfo.url, "Chat_Window", windowInfo.options);
    }

    function isChatActive () {
      // Chat not active for default experience
      return TierUtils.hasBrand && moment().isBetween(chatStart, chatEnd);
    }
  }
})();

/**
 * @ngdoc function
 * @name afiNgServicesApp.service:BrandsService
 * @description
 * # BrandsService
 * Service for pulling all brand information
 */
(function() {
  'use strict';

  angular
    .module('afiNgServicesApp')
    .factory('BrandsService', BrandsService);

  BrandsService.$inject = ['$http', '$q'];

  function BrandsService($http, $q) {
    var self = this;

    self.getBrandsInformation = function (brandUrl, TierUtils) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        url: brandUrl,
        headers: {
          'AFI-AppName': TierUtils.config.afiAppName,
          'AFI-API-Key': TierUtils.config.afiApiKey
        },
        cache: true
      }).then(function successCallback(data) {
          deferred.resolve(data.data);
        }, function errorCallback(data) {
          deferred.reject(data);
        });
      return deferred.promise;
    };
    return self;
  };
})();

'use strict';

/**
 * @ngdoc function
 * @name afiNgServicesApp.service:BannerService
 * @description
 * # ClientService
 * Service to share banner state between controllers
 */

angular.module('afiNgServicesApp')
  .factory('BannerService', function ($rootScope) {
    var service = {
      toggle: toggle,
      getBannerState: getBannerState
    };
    return service;

    function toggle() {
      var toggleState = $rootScope.hideBanner !== $rootScope.hideBanner;
      return toggleState;
    }

    function getBannerState() {
      return $rootScope.hideBanner;
    }

  });

/**
 * Created by msc023 on 3/30/16.
 */
angular.module('afiNgServicesApp')
  .constant('AppConstants', {
    usStates: [
      {
        name: 'Alabama',
        label: 'Alabama - AL',
        code: 'AL'
      },
      {
        name: 'Alaska',
        label: 'Alaska - AK',
        code: 'AK'
      },
      {
        name: 'Arizona',
        label: 'Arizona - AZ',
        code: 'AZ'
      },
      {
        name: 'Arkansas',
        label: 'Arkansas - AR',
        code: 'AR'
      },
      {
        name: 'California',
        label: 'California - CA',
        code: 'CA'
      },
      {
        name: 'Colorado',
        label: 'Colorado - CO',
        code: 'CO'
      },
      {
        name: 'Connecticut',
        label: 'Connecticut - CT',
        code: 'CT'
      },
      {
        name: 'Delaware',
        label: 'Delaware - DE',
        code: 'DE'
      },
      {
        name: 'District of Columbia',
        label: 'District of Columbia - DC',
        code: 'DC'
      },
      {
        name: 'Florida',
        label: 'Florida - FL',
        code: 'FL'
      },
      {
        name: 'Georgia',
        label: 'Georgia - GA',
        code: 'GA'
      },
      {
        name: 'Hawaii',
        label: 'Hawaii - HI',
        code: 'HI'
      },
      {
        name: 'Idaho',
        label: 'Idaho - ID',
        code: 'ID'
      },
      {
        name: 'Illinois',
        label: 'Illinois - IL',
        code: 'IL'
      },
      {
        name: 'Indiana',
        label: 'Indiana - IN',
        code: 'IN'
      },
      {
        name: 'Iowa',
        label: 'Iowa - IA',
        code: 'IA'
      },
      {
        name: 'Kansas',
        label: 'Kansas - KS',
        code: 'KS'
      },
      {
        name: 'Kentucky',
        label: 'Kentucky - KY',
        code: 'KY'
      },
      {
        name: 'Louisiana',
        label: 'Louisiana - LA',
        code: 'LA'
      },
      {
        name: 'Maine',
        label: 'Maine - ME',
        code: 'ME'
      },
      {
        name: 'Maryland',
        label: 'Maryland - MD',
        code: 'MD'
      },
      {
        name: 'Massachusetts',
        label: 'Massachusetts - MA',
        code: 'MA'
      },
      {
        name: 'Michigan',
        label: 'Michigan - MI',
        code: 'MI'
      },
      {
        name: 'Minnesota',
        label: 'Minnesota - MN',
        code: 'MN'
      },
      {
        name: 'Mississippi',
        label: 'Mississippi - MS',
        code: 'MS'
      },
      {
        name: 'Missouri',
        label: 'Missouri - MO',
        code: 'MO'
      },
      {
        name: 'Montana',
        label: 'Montana - MT',
        code: 'MT'
      },
      {
        name: 'Nebraska',
        label: 'Nebraska - NE',
        code: 'NE'
      },
      {
        name: 'Nevada',
        label: 'Nevada - NV',
        code: 'NV'
      },
      {
        name: 'New Hampshire',
        label: 'New Hampshire - NH',
        code: 'NH'
      },
      {
        name: 'New Jersey',
        label: 'New Jersey - NJ',
        code: 'NJ'
      },
      {
        name: 'New Mexico',
        label: 'New Mexico - NM',
        code: 'NM'
      },
      {
        name: 'New York',
        label: 'New York - NY',
        code: 'NY'
      },
      {
        name: 'North Carolina',
        label: 'North Carolina - NC',
        code: 'NC'
      },
      {
        name: 'North Dakota',
        label: 'North Dakota - ND',
        code: 'ND'
      },
      {
        name: 'Ohio',
        label: 'Ohio - OH',
        code: 'OH'
      },
      {
        name: 'Oklahoma',
        label: 'Oklahoma - OK',
        code: 'OK'
      },
      {
        name: 'Oregon',
        label: 'Oregon - OR',
        code: 'OR'
      },
      {
        name: 'Pennsylvania',
        label: 'Pennsylvania - PA',
        code: 'PA'
      },
      {
        name: 'Rhode Island',
        label: 'Rhode Island - RI',
        code: 'RI'
      },
      {
        name: 'South Carolina',
        label: 'South Carolina - SC',
        code: 'SC'
      },
      {
        name: 'South Dakota',
        label: 'South Dakota - SD',
        code: 'SD'
      },
      {
        name: 'Tennessee',
        label: 'Tennessee - TN',
        code: 'TN'
      },
      {
        name: 'Texas',
        label: 'Texas - TX',
        code: 'TX'
      },
      {
        name: 'Utah',
        label: 'Utah - UT',
        code: 'UT'
      },
      {
        name: 'Vermont',
        label: 'Vermont - VT',
        code: 'VT'
      },
      {
        name: 'Virginia',
        label: 'Virginia - VA',
        code: 'VA'
      },
      {
        name: 'Washington',
        label: 'Washington - WA',
        code: 'WA'
      },
      {
        name: 'West Virginia',
        label: 'West Virginia - WV',
        code: 'WV'
      },
      {
        name: 'Wisconsin',
        label: 'Wisconsin - WI',
        code: 'WI'
      },
      {
        name: 'Wyoming',
        label: 'Wyoming - WY',
        code: 'WY'
      }]

  });

(function () {
  "use strict";
  angular.module('com.amfam.services')
    .provider('TagManager', function () {
      var self = this;
      var settings = {
        created: false,
        accountId: null,
        appName: null,
        dataLayer: 'dataLayer',
        sessionId: null
      };

      /**
       * Config Methods
       */
      self.setAccount = function (id) {
        settings.accountId = id;
        return true;
      };

      self.setAppName = function (appName) {
        settings.appName = appName;
        return true;
      };

      self.setDataLayer = function (dl) {
        settings.dataLayer = dl;
        return true;
      };

      /**
       * Public Service
       */
      this.$get = ['$window', function ($window) {

        /**
         * Push data into the GTM dataLayer
         * @param data
         * @private
         */
        self._push = function (data) {
          $window[settings.dataLayer].push(data);
        };

        /**
         * Creates the GTM script
         * @returns {boolean}
         * @private
         */
        self._createScriptTag = function () {
          if (!settings.accountId) {
            return false;
          }

          if (settings.created) {
            return true;
          }

          //setup the datalayer and push the application name
          var dataLayer = window[settings.dataLayer] = window[settings.dataLayer] || [];
          dataLayer.push({
            'event': 'set-app-name',
            'appName': settings.appName,
          });

          //inject the tag manager script
          (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
              'gtm.start': new Date().getTime(), event: 'gtm.js'
            });
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s), dl = l !== 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src =
              '//www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
          })(window, document, 'script', settings.dataLayer, settings.accountId);
          settings.created = true;
          return true;
        };

        // create the tag manager script
        self._createScriptTag();

        return {
          push: function (data) {
            self._push(data);
          },

          /**
           * Send content view to the dataLayer for page tracking in Google Analytics
           * @name trackPage
           *
           * @param {string} path Required 'content name' (string) describes the content loaded
           */
          trackPage: function (path) {
            self._push({
              'event': 'content-view',
              'content-name': path,
              'userId': settings.sessionId
            });

          },

          /**
           * Send interactions to the dataLayer for event tracking in Google Analytics
           * @name trackEvent
           *
           * @param {string} action Required 'action' (string) associated with the event
           * @param {object} properties Comprised of the mandatory field 'category' (string)
           *  and optional fields 'label' (string), 'value' (integer) and 'noninteraction' (boolean)
           */
          trackEvent: function (action, properties) {
            properties = properties || {};
            self._push({
              'event': properties.event || 'interaction',
              'target': properties.category,
              'action': action,
              'target-properties': properties.label,
              'value': properties.value,
              'interaction-type': properties.noninteraction,
              'userId': settings.sessionId
            });
          },

          /**
           * Send timing to the data layer for user timings in Google Analytics
           * @name trackTiming
           *
           * @param {object} properties Comprised of the mandatory fields:
           *     'timingCategory' (string),
           *     'timingVar' (string),
           *     'timingValue' (number)
           * Properties can also have the optional fields:
           *     'timingLabel' (string)
           *
           * @link https://developers.google.com/analytics/devguides/collection/analyticsjs/user-timings
           */
          trackTiming: function (properties) {
            self._push({
              'event': 'timing',
              'timingCategory': properties.timingCategory,
              'timingVar': properties.timingVar,
              'timingValue': properties.timingValue,
              'timingLabel': properties.timingLabel,
              'userId': settings.sessionId
            });
          },

          setSessionId: function (id) {
            settings.sessionId = id;
          }
        };

      }];
    })
    .directive('gtmTrackEvent', ['tagManager', '$parse', function (tagManager, $parse) {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          var options = $parse(attrs.gtmTrackEvent);
          element.bind('click', function () {
            if (options.length > 1) {
              tagManager.push.apply(tagManager, options(scope));
            }
          });
        }
      };
    }]);
}());


/**
 * Created by msc023 on 4/12/16.
 */
(function () {
  "use strict";
  angular.module('com.amfam.services')
    .provider('AfEncrypt', function () {
      var self = this;
      var settings = {
        key: null,
        iv: null
      };

      /**
       * Config Methods
       */
      self.setKey = function (key) {
        settings.key = key;
        return true;
      };

      self.setIv = function (iv) {
        settings.iv = iv;
        return true;
      };

      /**
       * Public Service
       */
      this.$get = function () {
        return {
          encrypt: function (data) {
            var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), settings.key, {iv: settings.iv}); // jshint ignore:line
            // Make the query url/web safe Base64
            return encodeURIComponent(encryptedData.toString());
          }
        };
      };
    });
}());



(function () {
  'use strict';

  angular
    .module('afiNgServicesApp')
    .directive('haveExperience', haveExperience);

  haveExperience.$inject = ['TierUtils', '$compile'];

  function haveExperience(TierUtils, $compile) {
    return {
      priority: 1,
      restrict: "A",
      compile: function (element, attrs) {
        attrs.$set('haveExperience', null);
        if (TierUtils.hasBrand) {
          // Have experience - recompile, keeping content
          return function (scope, element) {
            // This technique used to avoid bug with ng-options duplicates, found at https://github.com/angular/angular.js/issues/4203
            $compile(element)(scope, function (clone) {
              element.after(clone);
              element.remove();
            });
          }
        } else {
          // Do not have experience - remove content
          element.empty();
        }
      }
    };
  }
})();





(function() {
  'use strict';

  angular
    .module('afiNgServicesApp')
    .directive('afValidDob', afValidDob);

  afValidDob.$inject = ['$moment'];
  function afValidDob(moment){
    return {
      require:  '?ngModel',
      restrict: 'A',
      link: function(scope, elm, attrs, ctrl) {
        // To check on the fly, do not check for form.$submitted in the ng-message
        var testValidity = ctrl.$validators.afValidDob = function (viewValue) {
          if (viewValue && attrs.afMinAge && attrs.afMaxAge) {         // Make certain that we have a value and min / max values
            var today = moment(),                                       // Get today
              dob = moment(viewValue, "MM/DD/YYYY"),                   // Parse the model value
              notEmpty = !ctrl.$isEmpty(viewValue),                    // Is there input?
              notInvalid = moment(viewValue, "MM/DD/YYYY").isValid(),  // Is the model value a date?
              underMinAge = today.diff(dob, 'years') >= attrs.afMinAge, // Is the user at least 14 years old
              overMaxAge = today.diff(dob, 'years') <= attrs.afMaxAge;  // Is the user under 99 years old
            return notEmpty && notInvalid && underMinAge && overMaxAge;
          }
        };

        // Check when updated in the view
        ctrl.$parsers.unshift(function (viewValue) {
          ctrl.$setValidity('afValidDob', testValidity);
          return testValidity ? viewValue : undefined;
        });

        // Check when updated programmatically
        ctrl.$formatters.unshift(function (viewValue) {
          ctrl.$setValidity('afValidDob', testValidity);
          return viewValue;
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('afiNgServicesApp')
    .directive('defaultExperience', defaultExperience);

  defaultExperience.$inject = ['TierUtils', '$compile'];

  function defaultExperience(TierUtils, $compile) {
    return {
      priority: 1,
      restrict: "A",
      compile: function (element, attrs) {
        attrs.$set('defaultExperience', null);
        if (TierUtils.hasBrand) {
          // Have experience - remove content
          element.empty();
        } else {
          // Do not have experience, use default - recompile, keeping content
          return function (scope, element) {
            // This technique used to avoid bug with ng-options duplicates, found at https://github.com/angular/angular.js/issues/4203
            $compile(element)(scope, function (clone) {
              element.after(clone);
              element.remove();
            });
          }
        }
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('afiNgServicesApp')
    .directive('allowPattern', allowOnly);

  allowOnly.$inject = [];

  function allowOnly() {


    return {
      require: 'ngModel',
      restrict: "A",
      compile: function() {
        return function(scope, element, attrs) {
          var pattern;

          // handle key events
          element.bind('keypress', function(event) {
            var keyCode = event.which || event.keyCode; // I safely get the keyCode pressed from the event.
            var keyCodeChar = String.fromCharCode(keyCode); // I determine the char from the keyCode.

            switch (attrs.allowPattern) {
              case 'alphanum':
                if (!keyCodeChar.match(new RegExp('[a-zA-Z0-9]', 'i'))) {
                  event.preventDefault();
                  return false;
                }
                break;
              case 'alpha':
                if (!keyCodeChar.match(new RegExp('[a-zA-Z]', 'i'))) {
                  event.preventDefault();
                  return false;
                }
                break;
              case 'num':
                if (!keyCodeChar.match(new RegExp('[a-zA-Z0-9]', 'i'))) {
                  event.preventDefault();
                  return false;
                }
                break;
              default:
                pattern = attrs.allowPattern;
                if (!keyCodeChar.match(new RegExp(pattern, 'i'))) {
                  event.preventDefault();
                  return false;
                }
            }
          });
        };
      }
    };
  }
})();





(function() {
  'use strict';

  angular
    .module('afiNgServicesApp')
    .directive('notifyGtm', notifyGtm);

  notifyGtm.$inject = ['TagManager'];

  function notifyGtm(TagManager) {
    /**
     * Notify GTM of user interaction changeValue events
     */
    function link(scope, element, attributes, ngModel) {

      element.bind('change', function () {

        var text = 'textContent' in document.body ? 'textContent' : 'innerText';
        var el = element && element[0] ? element[0] : '';

        if (el) {

          var label = ((document.querySelector('[for="' + el.id + '"]') || '')[text] || '').trim();

          TagManager.push({
            event: 'ngNotifyGtm',
            input: {
              element: el,
              id: el.id,
              label: label,
              type: el.type,
              value: ngModel.$modelValue
            }
          });

        }
      });
    }

    return {
      require: 'ngModel',
      restrict: 'A',
      link: link,
      scope: {
        ngModel: '='
      }
    };
  }

})();

'use strict';

/**
 * @ngdoc function
 * @name afiNgServicesApp.controller:ReportClaimCtrl
 * @description
 * # ReportClaimCtrl
 * Controller of the afiNgServicesApp
 */
angular.module('afiNgServicesApp')
  .controller('ReportClaimCtrl', function ($scope, $state) {
    var vm = this;
    vm.submitForm = function () {
      vm.submittingPolicyType = true;
      switch (vm.policyType.code) {
        case 'auto':
          $state.go('main.report-claim.auto');
          break;
        case 'condo':
          $state.go('main.report-claim.condo');
          break;
        case 'home':
        case 'second home':
          $state.go('main.report-claim.home');
          break;
        case 'renters':
          $state.go('main.report-claim.renters');
          break;
        default:
          break;
      }

      vm.submittingPolicyType = false;
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name afiNgServicesApp.controller:RentersClaimCtrl
 * @description
 * # RentersClaimCtrl
 * Controller of the afiNgServicesApp
 */
angular.module('afiNgServicesApp')
  .controller('RentersClaimCtrl', function ($scope, $window, TierUtils, UtilityService) {
    var vm = this;

    vm.submitForm = function (form) {
      if(form.$valid) {
        var rentersClaimUrl = TierUtils.brand.propertyServiceURL;
        UtilityService.goToUrl(rentersClaimUrl);
      }
    };
  });

'use strict';

/**
 * @ngdoc function
 * @name afiNgServicesApp.controller:QuoteRetrieveCtrl
 * @description
 * # QuoteRetrieveCtrl
 * Controller of the afiNgServicesApp
 */
angular.module('afiNgServicesApp')
  .controller('QuoteRetrieveCtrl', function ($rootScope, $scope, $state, $window, TierUtils) {
    var vm = this;
    var main = $scope.parent;
    $rootScope.$state = $state;
    vm.quoteSelected = false;

    vm.formReset = function(resetState, state, banner) {
      if(typeof(banner) === 'undefined') {
        banner = false;
      }
      vm.st(resetState);
      main.hideBanner = banner;
      vm.quoteSelected = false;
      $state.go(resetState);
    };

    vm.submitForm = function (form) {
      vm.retrievingQuote = true;
      switch (form.quotePolicyType.$modelValue.code) {
        case 'auto':
          vm.quoteSelected = true;
          $state.go('main.quote-retrieve.auto');
          break;
        case 'commercial':
          vm.quoteSelected = true;
          $state.go('main.quote-retrieve.commercial');
          break;
        case 'condo':
          vm.quoteSelected = true;
          $state.go('main.quote-retrieve.condo');
          break;
        case 'home':
        case 'second home':
          vm.quoteSelected = true;
          $state.go('main.quote-retrieve.home');
          break;
        case 'life':
          vm.quoteSelected = true;
          $window.location.href = TierUtils.config.lifeUrl + TierUtils.brand.partnerNameInUrl;
          break;
        case 'renters':
          vm.quoteSelected = true;
          $state.go('main.quote-retrieve.renters');
          break;
        default:
          break;
      }

      vm.retrievingQuote = false;
    };
  }
);

(function() {
  'use strict';

  angular
    .module('afiNgServicesApp')
    .controller('MainCtrl', MainCtrl);

  MainCtrl.$inject = ['$state', '$rootScope', '$scope', 'matchmedia', 'TierUtils', 'OffCanvas', 'BrandsService'];

  function MainCtrl($state, $rootScope, $scope, matchmedia, TierUtils, OffCanvas, BrandsService) {
    var vm = this, unsub;

    // URLs
    vm.expid = TierUtils.params.expid;
    vm.msid = TierUtils.params.msid;
    vm.params = 'msid=' + vm.msid;
    vm.propertyParams = 'expid=' + vm.expid + '&msid=' + vm.msid;
    vm.brandsUrl = TierUtils.config.brandsUrl + '?experienceId=' + vm.expid;
    vm.autoMyAccountUrl = TierUtils.config.myaccount2016BaseUrl + vm.expid + '/login?msid=' + vm.msid;
    TierUtils.autoMyAccountUrl = vm.autoMyAccountUrl;

    vm.myaccount2016EnrollUrl = TierUtils.config.myaccount2016BaseUrl + vm.expid + '/enroll/personal';
    vm.footerUrl = TierUtils.config.footerUrl;

    // Use offcanvas service to emit navToggle to rootScope
    vm.offCanvasToggle = OffCanvas.toggle;
    vm.offCanvasOpen = OffCanvas.open;
    vm.offCanvasClose = OffCanvas.close;

    // Listen for navToggle
    $rootScope.$on('navToggle', function( event, data ){
      vm.navToggleStatus = data;
    });

    vm.branded = $state.current.data.branded;

    // Get client display information
    vm.viewProperty = {};
    vm.viewProperty = {
      orientation: { landscape: true, portrait: false },
      device: { desktop: true, phone: false, tablet: false },
      screen: { screen: true, print: false }
    };

    function buildPolicyTypesForDropdowns(policyTypesString) {
      if (typeof policyTypesString === 'string') {
        vm.quotePolicyTypes = policyTypesString.split("|")
                                               .map(function (element) {
                                                 return { name: element, code: element.toLowerCase() };
                                               });

        vm.claimAndLoginPolicyTypes = vm.quotePolicyTypes.filter(function (obj) {
          return obj.code !== 'commercial' && obj.code !== 'life';
        });
      }
    }

    // Get brands information
    if (TierUtils.hasBrand && !TierUtils.brandRetrieved) {
      vm.brandsInfo = BrandsService.getBrandsInformation(vm.brandsUrl, TierUtils);
      vm.brandsInfo.then(function (response) {
        TierUtils.brandRetrieved = true;
        var myAccountCusCareDetails = {},
          genAssets = response.summaries[0].brand.productLines[0].genAssets,
          digitalAssets = response.summaries[0].brand.productLines[0].digitalAssets;
        vm.brand = {};
        TierUtils.brand = {};
        for (var i = 0; i < genAssets.length; i++) {
          if (genAssets[i].genAssetDesc == 'MyAccount_Connect_CusCare_Details') {
            myAccountCusCareDetails = genAssets[i].genAssetAttrs;
            angular.forEach(myAccountCusCareDetails, function (value) {
              switch (value.genAssetAttrKeyId) {
                case 'MyAccount_Connect_ClaimPhoneNum':
                  vm.brand.connectClaimNo = TierUtils.brand.connectClaimNo = value.assetAttrValueTxt;
                  break;
                case 'MyAccount_Connect_CusCareNumber':
                  vm.brand.connectCusCareNo = TierUtils.brand.connectCusCareNo = value.assetAttrValueTxt;
                  break;
                case 'MyAccount_Connect_CusCare_Email':
                  vm.brand.connectCusCareEmail = TierUtils.brand.connectCusCareEmail = value.assetAttrValueTxt;
                  break;
                case 'MyAccount_Connect_CusCare_Hours_WDay':
                  vm.brand.connectCusCareHoursWday = TierUtils.brand.connectCusCareHoursWday = value.assetAttrValueTxt;
                  break;
                case 'MyAccount_Connect_CommercialPhoneNum':
                  vm.brand.connectCommercialCusCareNo = TierUtils.brand.connectCommercialCusCareNo = value.assetAttrValueTxt;
                  break;
                case 'MyAccount_Connect_Commercial_Hours_WDay':
                  vm.brand.connectCommercialCusCareHoursWday = TierUtils.brand.connectCommercialCusCareHoursWday = value.assetAttrValueTxt;
                  break;
                case 'policyTypesEnabled':
                  vm.brand.policyTypesEnabled = TierUtils.brand.policyTypesEnabled = value.assetAttrValueTxt;
                  break;
                case 'retrieveQuoteEnabled':
                  var retrieveQuoteEnabled = value.assetAttrValueTxt === 'true' ? true : false;
                  vm.brand.retrieveQuoteEnabled = TierUtils.brand.retrieveQuoteEnabled = retrieveQuoteEnabled;
                  break;
                default:
                  break;
              }
            });
          }
          if (genAssets[i].genAssetDesc == 'MyAccount_DMSI') {
            myAccountCusCareDetails = genAssets[i].genAssetAttrs;
            angular.forEach(myAccountCusCareDetails, function (value) {
              switch (value.genAssetAttrKeyId) {
                case 'PartnerName_In_URL':
                  vm.brand.partnerNameInUrl = TierUtils.brand.partnerNameInUrl = value.assetAttrValueTxt;
                  break;
                case 'Company':
                  vm.brand.company = TierUtils.brand.company = value.assetAttrValueTxt;
                  break;
                case 'PropertyServiceURL':
                  vm.brand.propertyServiceURL = value.assetAttrValueTxt;
                  break;
                default:
                  break;
              }
            });
          }
        }
        var propertyServiceURL = vm.brand.propertyServiceURL;
        if (!propertyServiceURL) {
          propertyServiceURL = TierUtils.config.propertyUrl;
        }
        vm.brand.propertyServiceURL = TierUtils.brand.propertyServiceURL = propertyServiceURL + '?' + vm.propertyParams;

        angular.forEach(digitalAssets, function (value) {
          switch (value.digitalAssetResourceDec) {
            case 'MyAccount_Headerimage_Logo':
              vm.brand.headerLogoPath = TierUtils.brand.headerLogoPath = value.relativeLocTxt;
              break;
            case 'MyAccount_Footerimage_Logo':
              vm.brand.footerLogoPath = TierUtils.brand.footerLogoPath = value.relativeLocTxt;
              break;
            default:
              break;
          }
        });
        buildPolicyTypesForDropdowns(vm.brand.policyTypesEnabled);

        // Default policy selection to auto
        vm.policyType = vm.quotePolicyTypes[0];
        vm.quotePolicyType = vm.quotePolicyTypes[0];
      });
    } else {
      vm.brand = TierUtils.brand;
      buildPolicyTypesForDropdowns(vm.brand.policyTypesEnabled);
      // Default policy selection to auto
      vm.policyType = vm.quotePolicyTypes[0];
    }

    // See: https://github.com/AnalogJ/matchmedia-ng
    unsub = {};
    unsub.print = matchmedia.onPrint(function(mediaQueryList){
      vm.viewProperty.screen.print = mediaQueryList.matches;
    }, $scope);
    unsub.screen = matchmedia.onScreen(function(mediaQueryList){
      vm.viewProperty.screen.screen = mediaQueryList.matches;
    }, $scope);
    unsub.phone = matchmedia.onPhone(function(mediaQueryList){
      vm.viewProperty.device.phone = mediaQueryList.matches;
    }, $scope);
    unsub.tablet = matchmedia.onTablet( function(mediaQueryList){
      vm.viewProperty.device.tablet = mediaQueryList.matches;
    }, $scope);
    unsub.desktop = matchmedia.onDesktop( function(mediaQueryList){
      vm.viewProperty.device.desktop = mediaQueryList.matches;
    }, $scope);
    unsub.portrait = matchmedia.onPortrait(function(mediaQueryList){
      vm.viewProperty.orientation.portrait = mediaQueryList.matches;
    }, $scope);
    unsub.landscape = matchmedia.onLandscape(function(mediaQueryList){
      vm.viewProperty.orientation.landscape = mediaQueryList.matches;
    }, $scope);

    $scope.$on('$destroy', function iVeBeenDismissed() {
      // remove listeners
      unsub.print();
      unsub.screen();
      unsub.phone();
      unsub.tablet();
      unsub.desktop();
      unsub.portrait();
      unsub.landscape();
    });

    // Fires when the top of the element with the in-view directive goes above the top of the page
    // See: https://github.com/thenikso/angular-inview
    vm.inview = function($inviewpart) {
      if($inviewpart === 'bottom' && !vm.viewProperty.device.phone) {

        vm.hideBanner = true;
      }
    };

    // open login if needed
    if ($state.current.name === "main.login") {
      vm.offCanvasOpen();
    }
  }

})();

/**
 * @ngdoc function
 * @name afiNgServicesApp.controller:HomeQuoteRetrieveCtrl
 * @description
 * # HomeQuoteRetrieveCtrl
 * Controller of the afiNgServicesApp
 */

(function () {
  'use strict';

  angular
    .module('afiNgServicesApp')
    .controller('HomeQuoteRetrieveCtrl', HomeQuoteRetrieveCtrl);

  HomeQuoteRetrieveCtrl.$inject = ['$state', 'TierUtils', 'UtilityService', '$moment', 'AfEncrypt'];
  /* @ngInject */
  function HomeQuoteRetrieveCtrl($state, TierUtils, UtilityService, moment, AfEncrypt) {
    var vm = this,
      EXPID_KEY = "{expid}",
      UTM_SOURCE_KEY = "{utm_source}",
      UTM_CAMPAIGN_KEY = "{utm_campaign}",
      UTM_MEDIUM_KEY = "{utm_medium}",
      UTM_TERM_KEY = "{utm_term}",
      MSID_KEY = "{msid}",
      CUSTOMER_KEY = "{retrieve}";
    vm.retrievingQuote = false;
    vm.selectedDob = null;

    if ($state.current.data.hideBanner) {
      vm.hideBanner = true;
    }

    vm.submitForm = function (form) {
      if (form.$valid) {
        vm.retrievingQuote = true;
        var product = $state.current.data.product ? $state.current.data.product : "homesales";
        var formDate = moment(vm.selectedDob, "MM/DD/YYYY").format('YYYY-MM-DD');

        var hostName = window.location.hostname.split('.');
        var routerUrl = (TierUtils.config.routerUrl).replace(/HOST/, hostName[1]);

        var homeSalesUrl = routerUrl + TierUtils.brand.partnerNameInUrl + '/sales/index.htm';
        homeSalesUrl += '?product=' + TierUtils.config.route[product];
        var encryptedCustomerData = AfEncrypt.encrypt({
            "zip": form.zipCode.$modelValue,
            "lastName": form.lastName.$modelValue,
            'email': form.email.$modelValue,
            'dob': formDate
        });
        if(TierUtils.params.utm_source === undefined || TierUtils.params.utm_campaign === undefined
          || TierUtils.params.utm_medium === undefined || TierUtils.params.utm_term === undefined) {
          homeSalesUrl += "&expid={expid}&msid={msid}&retrieve={retrieve}";
          homeSalesUrl = homeSalesUrl.replace(EXPID_KEY, TierUtils.params.expid)
            .replace(MSID_KEY, TierUtils.params.msid)
            .replace(CUSTOMER_KEY, encryptedCustomerData);
        } else {
          homeSalesUrl += "&expid={expid}&msid={msid}&utm_source={utm_source}&utm_campaign={utm_campaign}&utm_medium={utm_medium}&utm_term={utm_term}&retrieve={retrieve}";
          homeSalesUrl = homeSalesUrl.replace(EXPID_KEY, TierUtils.params.expid)
            .replace(MSID_KEY, TierUtils.params.msid)
            .replace(UTM_SOURCE_KEY, TierUtils.params.utm_source)
            .replace(UTM_CAMPAIGN_KEY, TierUtils.params.utm_campaign)
            .replace(UTM_MEDIUM_KEY, TierUtils.params.utm_medium)
            .replace(UTM_TERM_KEY, TierUtils.params.utm_term)
            .replace(CUSTOMER_KEY, encryptedCustomerData);
        }

        // Forward to router
        UtilityService.goToUrl(homeSalesUrl);
      }
    };
  }
})();

'use strict';

/**
 * @ngdoc function
 * @name afiNgServicesApp.controller:HomeClaimCtrl
 * @description
 * # HomeClaimCtrl
 * Controller of the afiNgServicesApp
 */
angular.module('afiNgServicesApp')
  .controller('HomeClaimCtrl', function ($window, TierUtils, UtilityService) {
    var vm = this;

    vm.submitForm = function () {
      var homeClaimUrl = TierUtils.brand.propertyServiceURL;
      UtilityService.goToUrl(homeClaimUrl);
    };

  });

'use strict';

/**
 * @ngdoc function
 * @name afiNgServicesApp.controller:HomeZipNeededCtrl
 * @description
 * # HomeZipNeededCtrl
 * Controller of the afiNgServicesApp
 */
angular.module('afiNgServicesApp')
  .controller('ContactCtrl', function () {

  });

'use strict';

/**
 * @ngdoc function
 * @name afiNgServicesApp.controller:CondoClaimCtrl
 * @description
 * # CondoClaimCtrl
 * Controller of the afiNgServicesApp
 */
angular.module('afiNgServicesApp')
  .controller('CondoClaimCtrl', function ($window, TierUtils, UtilityService) {
    var vm = this;

    vm.submitForm = function () {
      var condoClaimUrl = TierUtils.brand.propertyServiceURL;
      UtilityService.goToUrl(condoClaimUrl);
    };

  });

/**
 * @ngdoc function
 * @name afiNgServicesApp.controller:AutoQuoteRetrieveCtrl
 * @description
 * # AutoQuoteRetrieveCtrl
 * Controller of the afiNgServicesApp
 */

(function () {
  'use strict';

  angular
    .module('afiNgServicesApp')
    .controller('AutoQuoteRetrieveCtrl', AutoQuoteRetrieveCtrl);

  AutoQuoteRetrieveCtrl.$inject = ['$state', 'TierUtils', 'UtilityService', '$moment', 'AfEncrypt'];
  /* @ngInject */
  function AutoQuoteRetrieveCtrl($state, TierUtils, UtilityService, moment, AfEncrypt) {
    var vm = this,
      EXPID_KEY = "{expid}",
      MSID_KEY = "{msid}",
      UTM_SOURCE_KEY = "{utm_source}",
      UTM_CAMPAIGN_KEY = "{utm_campaign}",
      UTM_MEDIUM_KEY = "{utm_medium}",
      UTM_TERM_KEY = "{utm_term}",
      CUSTOMER_KEY = "{retrieve}";
    vm.retrievingQuote = false;
    vm.selectedDob = null;
    vm.referenceId = '';

    var hostName = window.location.hostname.split('.');
    var routerUrl = (TierUtils.config.routerUrl).replace(/HOST/, hostName[1]);

    vm.retrieveQuoteUrl = routerUrl + TierUtils.brand.partnerNameInUrl + '/sales/index.htm?product=' + TierUtils.config.route.auto;

    if ($state.current.data.hideBanner) {
      vm.hideBanner = true;
    }

    vm.submitForm = function (form) {
      if (form.$valid) {
        vm.retrievingQuote = true;
        var formDate = vm.selectedDob;
        if (Object.prototype.toString.call(formDate) === '[object Date]') {     // Is a date object?
          formDate = UtilityService.dateSubmitFormat(vm.selectedDob);           // Yes - Send to service to get back a YYYY-MM-DD string.
        } else if (moment(vm.selectedDob, "MM/DD/YYYY")) {                      // Can Moment make it a date assuming it's in the MM/DD/YYYY format
          formDate = moment(vm.selectedDob, "MM/DD/YYYY").format('YYYY-MM-DD'); // Yes, change the format to YYYY-MM-DD for digitalsales
        }
        var salesUrl = vm.retrieveQuoteUrl;
        var encryptedCustomerData = AfEncrypt.encrypt({
            "zipCode": form.zipCode.$modelValue,
            "lastName": form.lastName.$modelValue,
            'email': form.email.$modelValue,
            'dob': formDate,
            'referenceId': form.referenceId.$modelValue
        });
        if(TierUtils.params.utm_source === undefined || TierUtils.params.utm_campaign === undefined
          || TierUtils.params.utm_medium === undefined || TierUtils.params.utm_term === undefined) {
          salesUrl += "&expid={expid}&msid={msid}&retrieve={retrieve}";
          salesUrl = salesUrl.replace(EXPID_KEY, TierUtils.params.expid)
            .replace(MSID_KEY, TierUtils.params.msid)
            .replace(CUSTOMER_KEY, encryptedCustomerData);
        } else {
          salesUrl += "&expid={expid}&msid={msid}&utm_source={utm_source}&utm_campaign={utm_campaign}&utm_medium={utm_medium}&utm_term={utm_term}&retrieve={retrieve}";
          salesUrl = salesUrl.replace(EXPID_KEY, TierUtils.params.expid)
            .replace(MSID_KEY, TierUtils.params.msid)
            .replace(UTM_SOURCE_KEY, TierUtils.params.utm_source)
            .replace(UTM_CAMPAIGN_KEY, TierUtils.params.utm_campaign)
            .replace(UTM_MEDIUM_KEY, TierUtils.params.utm_medium)
            .replace(UTM_TERM_KEY, TierUtils.params.utm_term)
            .replace(CUSTOMER_KEY, encryptedCustomerData);
        }
        // Forward to digitalsales
        UtilityService.goToUrl(salesUrl);
      }
    };
  }
})();

/**
 * @ngdoc function
 * @name afiNgServicesApp.controller:AutoClaimCtrl
 * @description
 * # AutoClaimCtrl
 * Controller of the afiNgServicesApp
 */

(function () {
  'use strict';

  angular
    .module('afiNgServicesApp')
    .controller('AutoClaimCtrl', AutoClaimCtrl);

  AutoClaimCtrl.$inject = ['$stateParams', '$http', '$httpParamSerializerJQLike', '$interval', '$state', '$scope', '$modal', '$location', '$anchorScroll', 'TierUtils', 'UtilityService', 'ChatService', 'AppConstants'];
  /* @ngInject */
  function AutoClaimCtrl($stateParams, $http, $httpParamSerializerJQLike, $interval, $state, $scope, $modal, $location, $anchorScroll, TierUtils, UtilityService, ChatService, AppConstants) {

    var vm = this,
        chatInfoModal = null;
    vm.incidentTime = null;
    vm.incidentDate = null;
    vm.submittingClaim = false;
    vm.confirmationReference = $stateParams.confirm;
    vm.chat = {};
    vm.usStates = AppConstants.usStates;

    vm.isChatActive = ChatService.isChatActive;
    vm.chat.active = vm.isChatActive();

    $interval(function () {
      vm.chat.active = vm.isChatActive();
    }, 60000);

    vm.chatInfoModal = function() {
      if(!ChatService.chatWindow || ChatService.chatWindow.closed) {
        if(vm.chat.active) {
          var templateURL = 'views/auto-claim-chat.html';
          var scope = $scope.$new();
          chatInfoModal = $modal({scope:scope, templateUrl: templateURL, show: true});
        }
      } else {
        chatInfoModal.hide();
        ChatService.chatWindow.focus();
      }
    };

    vm.goToLogin = function () {
      var autoClaimUrl = TierUtils.autoMyAccountUrl;
      UtilityService.goToUrl(autoClaimUrl);
    };

    vm.initChat = function(form) {
      if(vm.isChatActive() && form.$valid) {
        chatInfoModal.hide();
        ChatService.connectToChat(form);
      }
    };

    vm.checkDate = function(form) { // TODO - Remove (used for testing)
      if(form.$valid) {
        var formattedDate = UtilityService.dateSubmitClaimFormat(vm.incidentDate);
        console.log('Formatted date check :: ',formattedDate);
      }
    };

    vm.checkTime = function(form) { // TODO - Remove (used for testing)
      if(form.$valid) {
        var formatTime = UtilityService.timeSubmitFormat(vm.incidentTime),
        hhmm = formatTime.hhmm,
        mer = formatTime.mer;
        console.log('Formatted time check :: ',hhmm,' ',mer);
      }
    };

    vm.checkDob = function(form) { // TODO - Remove (used for testing)
      if(form.$valid) {
        var formattedDob = UtilityService.dateSubmitFormat(vm.selectedDob);
        console.log('Formatted dob check :: ',formattedDob);
      }
    };

    vm.submitForm = function (form) {
      if (form.$valid) {
        vm.submittingClaim = true;

        var formatTime = UtilityService.timeSubmitFormat(vm.incidentTime),
          hhmm = formatTime.hhmm,
          mer = formatTime.mer;

        // TODO - Combine date and time to get accident date and time in one object
        // TODO - Figure out how to handle timezones

        var formData = {
          firstName: vm.firstName,
          lastName: vm.lastName,
          policyNumber: vm.policyNumber,
          address1: vm.address1,
          address2: vm.address2,
          city: vm.city,
          state: vm.state.code,
          zipcode: vm.zipCode,
          email: vm.email,
          phone: vm.phone,
          extension: vm.extension,
          incidentDate: UtilityService.dateSubmitClaimFormat(vm.incidentDate),
          incidentTime: hhmm,
          incidentPeriod: mer,
          incidentLocation: vm.incidentLocation,
          incidentDescription: vm.incidentDescription
        };

        $http({
          method: 'POST',
          url: TierUtils.config.submitClaimService,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          data: $httpParamSerializerJQLike(formData)
        }).then(function successCallback(response) {
          console.log(response.data.referenceNumber);
          $state.go('confirm.auto-claim', {confirm: response.data.referenceNumber});
        }, function errorCallback() {
          $location.hash('top');
          $anchorScroll();
          vm.submitClaimError = true;
        }).finally(function () {
          vm.submittingClaim = false;
        });
      }
    };
  }
})();

angular.module("afiNgServicesApp").run(["$templateCache", function($templateCache) {$templateCache.put("404.html","<!doctype html><html lang=\"en\"><head><meta charset=\"utf-8\"><title>Page Not Found :(</title><style>\n      ::-moz-selection {\n        background: #b3d4fc;\n        text-shadow: none;\n      }\n\n      ::selection {\n        background: #b3d4fc;\n        text-shadow: none;\n      }\n\n      html {\n        padding: 30px 10px;\n        font-size: 20px;\n        line-height: 1.4;\n        color: #737373;\n        background: #f0f0f0;\n        -webkit-text-size-adjust: 100%;\n        -ms-text-size-adjust: 100%;\n      }\n\n      html,\n      input {\n        font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n      }\n\n      body {\n        max-width: 500px;\n        padding: 30px 20px 50px;\n        border: 1px solid #b3b3b3;\n        border-radius: 4px;\n        margin: 0 auto;\n        box-shadow: 0 1px 10px #a7a7a7, inset 0 1px 0 #fff;\n        background: #fcfcfc;\n      }\n\n      h1 {\n        margin: 0 10px;\n        font-size: 50px;\n        text-align: center;\n      }\n\n      h1 span {\n        color: #bbb;\n      }\n\n      h3 {\n        margin: 1.5em 0 0.5em;\n      }\n\n      p {\n        margin: 1em 0;\n      }\n\n      ul {\n        padding: 0 0 0 40px;\n        margin: 1em 0;\n      }\n\n      .container {\n        max-width: 380px;\n        margin: 0 auto;\n      }\n\n      /* google search */\n\n      #goog-fixurl ul {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n      }\n\n      #goog-fixurl form {\n        margin: 0;\n      }\n\n      #goog-wm-qt,\n      #goog-wm-sb {\n        border: 1px solid #bbb;\n        font-size: 16px;\n        line-height: normal;\n        vertical-align: top;\n        color: #444;\n        border-radius: 2px;\n      }\n\n      #goog-wm-qt {\n        width: 220px;\n        height: 20px;\n        padding: 5px;\n        margin: 5px 10px 0 0;\n        box-shadow: inset 0 1px 1px #ccc;\n      }\n\n      #goog-wm-sb {\n        display: inline-block;\n        height: 32px;\n        padding: 0 10px;\n        margin: 5px 0 0;\n        white-space: nowrap;\n        cursor: pointer;\n        background-color: #f5f5f5;\n        background-image: -webkit-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        background-image: -moz-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        background-image: -ms-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        background-image: -o-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n      }\n\n      #goog-wm-sb:hover,\n      #goog-wm-sb:focus {\n        border-color: #aaa;\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n        background-color: #f8f8f8;\n      }\n\n      #goog-wm-qt:hover,\n      #goog-wm-qt:focus {\n        border-color: #105cb6;\n        outline: 0;\n        color: #222;\n      }\n\n      input::-moz-focus-inner {\n        padding: 0;\n        border: 0;\n      }\n    </style></head><body><div class=\"container\"><h1>Not found <span>:(</span></h1><p>Sorry, but the page you were trying to view does not exist.</p><p>It looks like this was the result of either:</p><ul><li>a mistyped address</li><li>an out-of-date link</li></ul><script>\n        var GOOG_FIXURL_LANG = (navigator.language || \'\').slice(0,2),GOOG_FIXURL_SITE = location.host;\n      </script><script src=\"//linkhelp.clients.google.com/tbproxy/lh/wm/fixurl.js\"></script></div></body></html>");
$templateCache.put("index.html","<!doctype html><html lang=\"en\"><head><meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\"><meta http-equiv=\"Cache-Control\" content=\"must-revalidate, proxy-revalidate, max-age=0\"><meta charset=\"utf-8\"><title>Midvale Insurance Program - Request a quote, retrieve an existing quote or file a claim online</title><meta name=\"description\" content=\"\"><meta name=\"viewport\" content=\"width=device-width, initial-scale=1, maximum-scale=1\"><meta name=\"robots\" content=\"noindex\"><script type=\"text/javascript\">\n      var urlParams = [];\n      window.location.search.substr(1).split(\"&\").forEach(function(item) {\n        var param = item.split(\"=\"),\n          paramKey = param[0],\n          paramVal = param[1] && decodeURIComponent(param[1]);\n        urlParams[paramKey] = paramVal;\n      });\n\n      // when no brand, redirect it to the new midvale marketing page\n      if (typeof urlParams.expid === \'undefined\') window.location.replace(\'https://go.midvaleinsurance.com\');\n\n    </script></head><body><noscript><iframe src=\"//www.googletagmanager.com/ns.html?id=GTM-NLHPCJ&event=set-app-name&appName=auto-services\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe></noscript><div ui-view=\"\" class=\"landing-body\"></div><link href=\"https://fonts.googleapis.com/css?family=Oswald:300,400,700\" rel=\"stylesheet\" type=\"text/css\"></body></html>");
$templateCache.put("views/auto-claim-chat.html","<div style=\"z-index:1100;\" class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog afi-claims-chat\"><div class=\"modal-content\"><div class=\"modal-header\"><h4 class=\"pull-left\"><span class=\"icon-chat\"></span>Chat with Us Online</h4><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button></div><div class=\"modal-body\"><div id=\"modal-content\"><form class=\"afi-form\" role=\"form\" name=\"claimChatForm\" novalidate=\"\" ng-submit=\"claim.initChat(claimChatForm)\"><div class=\"row\"><div class=\"col-sm-12\"><p>Chat is available for auto claims questions. Simply provide the requested information and select \"Start Chat\". You may also contact us at {{main.brand.connectClaimNo}}.</p></div></div><hr><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : claimChatForm.$submitted && !claimChatForm.firstName.$valid}\"><label class=\"control-label\" for=\"firstName\">First Name</label> <span class=\"input-field-note control-label\" ng-messages=\"claimChatForm.firstName.$error\" ng-show=\"claimChatForm.$submitted && !claim.firstName.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">(required input)</span></span><div class=\"afi-input\"><input type=\"text\" id=\"firstName\" name=\"firstName\" ng-model=\"claim.firstName\" class=\"form-control\" required=\"\"> <span class=\"underline\"></span></div></div><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : claimChatForm.$submitted && !claimChatForm.lastName.$valid}\"><label class=\"control-label\" for=\"lastName\">Last Name</label> <span class=\"input-field-note control-label\" ng-messages=\"claimChatForm.lastName.$error\" ng-show=\"claimChatForm.$submitted && !claim.lastName.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">(required input)</span></span><div class=\"afi-input\"><input type=\"text\" id=\"lastName\" name=\"lastName\" ng-model=\"claim.lastName\" class=\"form-control\" required=\"\"> <span class=\"underline\"></span></div></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-4\" ng-class=\"{ \'has-error\' : claimChatForm.$submitted && !claimChatForm.state.$valid}\"><label class=\"control-label\" for=\"state\">State</label> <span class=\"input-field-note control-label\" ng-messages=\"claimChatForm.state.$error\" ng-show=\"claimChatForm.$submitted && !claim.state.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">(required input)</span></span><div class=\"afi-input\"><select id=\"state\" name=\"state\" ng-model=\"claim.state\" ng-options=\"state.label for state in claim.usStates track by state.code\" class=\"form-control\" required=\"\" notify-gtm=\"\"><option value=\"\" selected=\"selected\">Select</option></select><span class=\"underline\"></span></div></div><div class=\"form-group col-xs-12 col-sm-3\" ng-class=\"{ \'has-error\' : claimChatForm.$submitted && !claimChatForm.zipCode.$valid}\"><label class=\"control-label\" for=\"zipCode\">ZIP</label> <span class=\"input-field-note control-label\" ng-messages=\"claimChatForm.zipCode.$error\" ng-show=\"claimChatForm.$submitted && !claim.zipCode.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">(required input)</span> <span ng-message=\"pattern\">must be 5 digits</span></span><div class=\"afi-input\"><input type=\"tel\" id=\"zipCode\" name=\"zipCode\" ng-model=\"claim.zipCode\" ng-change=\"\" class=\"form-control\" ng-pattern=\"/^\\d{5}$/\" maxlength=\"5\" required=\"\"> <span class=\"underline\"></span></div></div></div><div class=\"row btn-row\"><div class=\"col-xs-12\"><a class=\"btn btn-afi-cancel\" ng-click=\"$hide()\">Cancel</a> <button type=\"submit\" class=\"btn btn-afi pull-right\" role=\"button\">Start Chat</button></div></div></form></div></div></div></div></div>");
$templateCache.put("views/auto-claim-confirm.html","<div class=\"row\"><div class=\"col-xs-12\" ng-class=\"claim.chat.active ? \'col-sm-8\' : \'col-sm-12\'\"><h3 class=\"hidden-xs\"><span class=\"icon-quote claim-icon\"></span>Success! We\'ve received your claim.</h3><h4>Auto Claim Reference #: {{claim.confirmationReference}}</h4><p>A customer care rep is reviewing your claim and will contact you soon with next steps. In the meantime, please call us at {{main.brand.connectClaimNo}} with any questions.</p><a class=\"btn btn-afi-back\" ui-sref=\"main.report-claim\" role=\"button\">Back</a></div><div class=\"col-xs-12 col-sm-4\" ng-show=\"claim.chat.active\"><div class=\"afi-well\"><h4><span class=\"icon-chat\"></span>Do you need some help?</h4><p>For auto claims questions, chat online with a customer care representative.</p><div class=\"btn-row\"><a class=\"btn btn-block btn-afi-secondary\" href=\"javascript:void(0);\" ng-click=\"claim.chatInfoModal()\" role=\"button\">Chat with us online</a></div></div></div></div>");
$templateCache.put("views/auto-claim-redirect.html","<form role=\"form\" name=\"claim.claimForm\" novalidate=\"\" ng-submit=\"claim.goToLogin()\"><div class=\"row\"><div class=\"col-xs-12\" ng-class=\"claim.chat.active ? \'col-sm-8\' : \'col-sm-12\'\"><h3><span class=\"icon-quote claim-icon\"></span>Dreams, restored.</h3><p class=\"header-support\">When the unexpected happens, we\'re here every step of the way to help you regroup and restore. To get started on your <span default-experience=\"\">auto claim please contact us at 1-866-328-9577.</span> <span have-experience=\"\">auto claim, please continue to login.</span></p></div><div class=\"col-xs-12 col-sm-4\" ng-show=\"claim.chat.active\"><div class=\"afi-well\"><h4><span class=\"icon-chat\"></span>Do you need some help?</h4><p>For auto claims questions, chat online with a customer care representative.</p><div class=\"btn-row\"><a class=\"btn btn-block btn-afi-secondary\" title=\"The current customer care center time is: {{claim.chat.hourDisplay}}:{{claim.chat.min}} {{claim.chat.meridiem}}\" href=\"javascript:void(0);\" ng-click=\"claim.chatInfoModal()\" role=\"button\">Chat with us online</a></div></div></div></div><div class=\"row btn-row\"><div class=\"col-xs-12\"><a class=\"btn btn-afi-cancel\" ui-sref=\"main.report-claim\" role=\"button\">Cancel</a> <button have-experience=\"\" class=\"btn btn-afi pull-right\" alt=\"Log in to file your claim\" type=\"submit\">Log in to file a claim</button></div></div></form>");
$templateCache.put("views/auto-claim.html","<div ng-show=\"claim.submitClaimError\" class=\"alert alert-danger\" role=\"alert\"><p>An error has occurred. Please validate that the information you entered below is correct.</p><p>If you continue to receive this error, please contact our Customer Care Center 24/7 at {{main.brand.connectClaimNo}}.</p></div><div class=\"row\"><div class=\"col-xs-12\" ng-class=\"claim.chat.active ? \'col-sm-8\' : \'col-sm-12\'\"><h3 class=\"hidden-xs\"><span class=\"icon-quote claim-icon\"></span>Dreams, restored.</h3><p>When the unexpected happens, we\'re here every step of the way to help you regroup and restore. To get your auto claim started just fill out this form. We\'ll take it from here.</p><p class=\"header-support\">For immediate assistance, please call us 24/7 at: {{main.brand.connectClaimNo}}</p><p class=\"required-text\">All fields required unless otherwise indicated</p></div><div class=\"col-xs-12 col-sm-4\" ng-show=\"claim.chat.active\"><div class=\"afi-well\"><h4><span class=\"icon-chat\"></span>Do you need some help?</h4><p>For auto claims questions, chat online with a customer care representative.</p><div class=\"btn-row\"><a class=\"btn btn-block btn-afi-secondary\" title=\"The current customer care center time is: {{claim.chat.hourDisplay}}:{{claim.chat.min}} {{claim.chat.meridiem}}\" href=\"javascript:void(0);\" ng-click=\"claim.chatInfoModal()\" role=\"button\">Chat with us online</a></div></div></div></div><hr><form class=\"afi-form\" role=\"form\" id=\"claimForm\" name=\"claimForm\" novalidate=\"\" ng-submit=\"claim.submitForm(claimForm)\"><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6 col-md-4\" ng-class=\"{ \'has-error\' : claimForm.$submitted && !claimForm.policyNumber.$valid}\"><label class=\"control-label\" for=\"policyNumber\">Policy Number</label> <span class=\"input-field-note pull-right\" ng-hide=\"claimForm.$submitted && !claim.policyNumber.$valid\"></span><div class=\"afi-input\"><input type=\"text\" id=\"policyNumber\" name=\"policyNumber\" ng-model=\"claim.policyNumber\" class=\"form-control\" ng-pattern=\"/^([a-zA-Z0-9]{10}|[a-zA-Z0-9]{12})$/\" maxlength=\"12\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"claimForm.policyNumber.$error\" ng-show=\"claimForm.$submitted && !claim.policyNumber.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"pattern\" class=\"ng-scope\">Invalid input</span></span></span></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6 col-md-4\" ng-class=\"{ \'has-error\' : claimForm.$submitted && !claimForm.firstName.$valid}\"><label class=\"control-label\" for=\"firstName\">First Name</label><div class=\"afi-input\"><input type=\"text\" id=\"firstName\" name=\"firstName\" ng-model=\"claim.firstName\" class=\"form-control\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"claimForm.firstName.$error\" ng-show=\"claimForm.$submitted && !claim.firstName.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"pattern\" class=\"ng-scope\">Invalid input</span></span></span></div><div class=\"form-group col-xs-12 col-sm-6 col-md-4\" ng-class=\"{ \'has-error\' : claimForm.$submitted && !claimForm.lastName.$valid}\"><label class=\"control-label\" for=\"lastName\">Last Name</label><div class=\"afi-input\"><input type=\"text\" id=\"lastName\" name=\"lastName\" ng-model=\"claim.lastName\" class=\"form-control\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"claimForm.lastName.$error\" ng-show=\"claimForm.$submitted && !claim.lastName.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"pattern\" class=\"ng-scope\">Invalid input</span></span></span></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6 col-md-4\" ng-class=\"{ \'has-error\' : claimForm.$submitted && !claimForm.email.$valid}\"><label class=\"control-label\" for=\"email\">Email Address</label><div class=\"afi-input\"><input type=\"email\" id=\"email\" name=\"email\" ng-model=\"claim.email\" class=\"form-control\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"claimForm.email.$error\" ng-show=\"claimForm.$submitted && !claim.email.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"email\" class=\"ng-scope\">Invalid input</span></span></span></div><div class=\"form-group col-xs-12 col-sm-4 col-md-4\" ng-class=\"{ \'has-error\' : claimForm.$submitted && !claimForm.phone.$valid}\"><label class=\"control-label\" for=\"phone\">Phone Number</label><div class=\"afi-input\"><input type=\"tel\" id=\"phone\" name=\"phone\" ng-model=\"claim.phone\" ng-pattern=\"/^\\(?(\\d{3})\\)?[ .-]?(\\d{3})[ .-]?(\\d{4})$/\" placeholder=\"(XXX) XXX-XXXX\" class=\"form-control\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"claimForm.phone.$error\" ng-show=\"claimForm.$submitted && !claim.phone.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"pattern\" class=\"ng-scope\">Invalid input</span></span></span></div><div class=\"form-group col-xs-12 col-sm-2\"><label class=\"control-label\" for=\"extension\">Ext</label> <span class=\"input-field-note pull-right\">Optional</span><div class=\"afi-input\"><input type=\"text\" id=\"extension\" name=\"extension\" ng-model=\"claim.extension\" class=\"form-control\"> <span class=\"underline\"></span></div></div></div><hr><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : claimForm.$submitted && !claimForm.address1.$valid}\"><label class=\"control-label\" for=\"address1\">Address Line 1</label><div class=\"afi-input\"><input type=\"text\" id=\"address1\" name=\"address1\" ng-model=\"claim.address1\" class=\"form-control\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"claimForm.address1.$error\" ng-show=\"claimForm.$submitted && !claim.address1.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span></span></span></div><div class=\"form-group col-xs-12 col-sm-6\"><label class=\"control-label\" for=\"address2\">Address Line 2</label> <span class=\"input-field-note pull-right\">Optional</span><div class=\"afi-input\"><input type=\"text\" id=\"address2\" ng-model=\"claim.address2\" class=\"form-control\"> <span class=\"underline\"></span></div></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : claimForm.$submitted && !claimForm.city.$valid}\"><label class=\"control-label\" for=\"city\">City</label><div class=\"afi-input\"><input type=\"text\" id=\"city\" name=\"city\" ng-model=\"claim.city\" class=\"form-control\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"claimForm.city.$error\" ng-show=\"claimForm.$submitted && !claim.city.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span></span></span></div><div class=\"form-group col-xs-12 col-sm-4\" ng-class=\"{ \'has-error\' : claimForm.$submitted && !claimForm.state.$valid}\"><label class=\"control-label\" for=\"state\">State</label><div class=\"afi-input\"><select id=\"state\" name=\"state\" ng-model=\"claim.state\" ng-options=\"state.label for state in claim.usStates track by state.code\" class=\"form-control\" required=\"\" notify-gtm=\"\"><option value=\"\" selected=\"selected\">Select</option></select><span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"claimForm.state.$error\" ng-show=\"claimForm.$submitted && !claim.state.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span></span></span></div><div class=\"form-group col-xs-12 col-sm-2\" ng-class=\"{ \'has-error\' : claimForm.$submitted && !claimForm.zipCode.$valid}\"><label class=\"control-label\" for=\"zipCode\">ZIP</label><div class=\"afi-input\"><input type=\"tel\" id=\"zipCode\" name=\"zipCode\" ng-model=\"claim.zipCode\" ng-change=\"\" class=\"form-control\" ng-pattern=\"/^\\d{5}$/\" maxlength=\"5\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"claimForm.zipCode.$error\" ng-show=\"claimForm.$submitted && !claim.zipCode.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"pattern\" class=\"ng-scope\">Invalid input</span></span></span></div></div><hr><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-5\" ng-class=\"{ \'has-error\' : claimForm.$submitted && claimForm.incidentDate.$invalid}\"><label class=\"control-label\" for=\"incidentDate\">Date of Incident</label><div class=\"input-group afi-datepicker\"><div class=\"afi-input right-inner-addon\"><i class=\"inner-addon glyphicon glyphicon-calendar\"></i> <input type=\"text\" class=\"form-control\" ng-model=\"claim.incidentDate\" placeholder=\"MM/DD/YYYY\" id=\"incidentDate\" name=\"incidentDate\" bs-datepicker=\"\" autoclose=\"true\" max-date=\"today\" date-format=\"MM/dd/yyyy\" use-native=\"true\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"claimForm.incidentDate.$error\" ng-show=\"claimForm.$submitted && !claimForm.incidentDate.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"incidentDate\" class=\"ng-scope\">Invalid date</span></span></span></div></div><div class=\"form-group col-xs-12 col-sm-5\" ng-class=\"{ \'has-error\' : claimForm.$submitted && claimForm.incidentTime.$invalid}\"><label class=\"control-label\" for=\"incidentTime\">Time of Incident</label><div class=\"input-group afi-timepicker\"><div class=\"afi-input right-inner-addon\"><i class=\"inner-addon glyphicon glyphicon-time\"></i> <input type=\"text\" class=\"form-control\" placeholder=\"HH:MM PM\" size=\"8\" ng-model=\"claim.incidentTime\" id=\"incidentTime\" name=\"incidentTime\" bs-timepicker=\"\" minute-step=\"1\" use-native=\"true\" time-format=\"hh:mm a\" show-meridian=\"true\" autoclose=\"1\" length=\"7\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"claimForm.incidentTime.$error\" ng-show=\"claimForm.$submitted && !quoteretrieveaincidentTto.incidentTime.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"date\" class=\"ng-scope\">Invalid date</span></span></span></div></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-5\" ng-class=\"{ \'has-error\' : claimForm.$submitted && !claimForm.incidentLocation.$valid}\"><label class=\"control-label\" for=\"incidentLocation\">Location of Incident</label><div class=\"afi-input\"><textarea id=\"incidentLocation\" name=\"incidentLocation\" ng-model=\"claim.incidentLocation\" class=\"form-control resizable\" required=\"\" notify-gtm=\"\">\n				</textarea> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"claimForm.incidentLocation.$error\" ng-show=\"claimForm.$submitted && !claim.incidentLocation.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span></span></span></div><div class=\"form-group col-xs-12 col-sm-5\" ng-class=\"{ \'has-error\' : claimForm.$submitted && !claimForm.incidentDescription.$valid}\"><label class=\"control-label\" for=\"incidentDescription\">Description of Incident</label><div class=\"afi-input\"><textarea id=\"incidentDescription\" name=\"incidentDescription\" ng-model=\"claim.incidentDescription\" class=\"form-control resizable\" required=\"\" notify-gtm=\"\">\n				</textarea> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"claimForm.incidentDescription.$error\" ng-show=\"claimForm.$submitted && !claim.incidentDescription.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span></span></span></div></div><div class=\"row btn-row\"><div class=\"col-xs-12\"><a class=\"btn btn-afi-cancel\" ui-sref=\"main.report-claim\" role=\"button\">Cancel</a> <button class=\"btn btn-afi pull-right\" type=\"submit\">File your claim</button></div></div></form>");
$templateCache.put("views/auto-quote-retrieve.html","<form class=\"afi-form\" role=\"form\" name=\"quoteRetrieveAutoForm\" novalidate=\"\" ng-submit=\"quoteretrieveauto.submitForm(quoteRetrieveAutoForm)\"><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"hidden-xs\"><span class=\"icon-review quote-icon\"></span>Find your auto quote</h3><p class=\"header-support\">Already started an auto quote? Nice work! Find it here in just a few clicks.</p><p class=\"required-text\">All fields required unless otherwise indicated</p></div></div><hr><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : quoteRetrieveAutoForm.$submitted && !quoteRetrieveAutoForm.lastName.$valid}\"><label class=\"control-label\" for=\"lastName\">Last Name</label><div class=\"afi-input\"><input type=\"text\" id=\"lastName\" name=\"lastName\" ng-model=\"quoteretrieveauto.lastName\" class=\"form-control\" ng-pattern=\"/^([a-zA-Z]+[,.]?[ ]?|[a-zA-Z]+[\'-]?)+$/\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"quoteRetrieveAutoForm.lastName.$error\" ng-show=\"quoteRetrieveAutoForm.$submitted && !quoteretrieveauto.lastName.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"pattern\" class=\"ng-scope\">Invalid input</span></span></span></div><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : quoteRetrieveAutoForm.$submitted && !quoteRetrieveAutoForm.email.$valid}\"><label class=\"control-label\" for=\"email\">Email</label><div class=\"afi-input\"><input type=\"email\" id=\"email\" name=\"email\" ng-model=\"quoteretrieveauto.email\" class=\"form-control\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"quoteRetrieveAutoForm.email.$error\" ng-show=\"quoteRetrieveAutoForm.$submitted && !quoteretrieveauto.email.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"email\" class=\"ng-scope\">Invalid input</span></span></span></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : quoteRetrieveAutoForm.$submitted && !quoteRetrieveAutoForm.zipCode.$valid}\"><label class=\"control-label\" for=\"zipCode\">ZIP</label><div class=\"afi-input\"><input type=\"tel\" id=\"zipCode\" name=\"zipCode\" ng-model=\"quoteretrieveauto.retrieveQuoteZip\" class=\"form-control\" ng-pattern=\"/^\\d{5}$/\" maxlength=\"5\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"quoteRetrieveAutoForm.zipCode.$error\" ng-show=\"quoteRetrieveAutoForm.$submitted && !quoteretrieveauto.zipCode.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"pattern\" class=\"ng-scope\">Invalid input</span></span></span></div><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : quoteRetrieveAutoForm.$submitted && quoteRetrieveAutoForm.dob.$error.required || quoteRetrieveAutoForm.dob.$error.afValidDob}\"><label class=\"control-label\" for=\"dob\">Date of Birth</label><div class=\"afi-input\"><input id=\"dob\" name=\"dob\" type=\"text\" class=\"form-control\" ng-model=\"quoteretrieveauto.selectedDob\" ui-mask=\"99/99/9999\" model-view-value=\"true\" ui-mask-placeholder=\"__/__/____\" af-min-age=\"14\" af-max-age=\"99\" af-valid-dob=\"\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"quoteRetrieveAutoForm.dob.$error\" role=\"alert\"><span ng-show=\"quoteRetrieveAutoForm.$submitted\" ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"afValidDob\" class=\"ng-scope\">Invalid date of birth</span></span></span></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : quoteRetrieveAutoForm.$submitted && !quoteRetrieveAutoForm.referenceId.$valid}\"><label class=\"control-label\" for=\"referenceId\">Quote Reference Number</label> <span class=\"input-field-note pull-right\">Optional</span><div class=\"afi-input\"><input type=\"text\" id=\"referenceId\" name=\"referenceId\" ng-model=\"quoteretrieveauto.referenceId\" class=\"form-control\" ng-pattern=\"/^[A-Za-z0-9]*$/\" maxlength=\"10\" allow-pattern=\"alphanum\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"quoteRetrieveAutoForm.referenceId.$error\" ng-show=\"quoteRetrieveAutoForm.$submitted && !quoteretrieveauto.referenceId.$valid\" role=\"alert\"><span ng-message=\"pattern\" class=\"ng-scope\">Invalid input</span></span></span></div></div><div class=\"row btn-row\"><div class=\"col-xs-12\"><a class=\"btn btn-afi-cancel\" ui-sref=\"main.quote-retrieve\" role=\"button\">Cancel</a> <button class=\"btn btn-afi pull-right\" ng-disabled=\"quoteretrieveauto.retrievingQuote\" type=\"submit\">Find auto quote</button></div></div></form>");
$templateCache.put("views/commercial-quote-retrieve.html","<form role=\"form\" class=\"afi-form\"><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"hidden-xs\"><span class=\"icon-review quote-icon\"></span>Find your commercial quote</h3><p class=\"header-support commercial\">Looking for your Commercial quote? Just click the link in the email you received from <span default-experience=\"\">Midvale Insurance Program</span> <span have-experience=\"\">{{main.brand.company}}</span>. If you can’t find the email, no worries. Give us a call, we’re happy to help.</p></div></div><div class=\"row\"><div class=\"col-sm-4\"><p>Customer Care Center</p><p>{{main.brand.connectCommercialCusCareNo}}</p></div><div class=\"col-sm-4\"><p>Hours of Operation:</p><p>{{main.brand.connectCommercialCusCareHoursWday}}</p></div></div><hr><div class=\"row btn-row\"><div class=\"col-xs-12\"><a class=\"btn btn-afi-cancel\" ui-sref=\"main.quote-retrieve\" role=\"button\">Cancel</a></div></div></form>");
$templateCache.put("views/condo-claim.html","<form role=\"form\" name=\"condo.claimForm\" novalidate=\"\" ng-submit=\"condo.submitForm(condo.claimForm)\"><h3><span class=\"icon-quote claim-icon\"></span>Dreams, restored.</h3><p class=\"header-support\">When the unexpected happens, we\'re here every step of the way to help you regroup and restore. To get started on your <span default-experience=\"\">property claim please contact us at 1-866-328-9577.</span> <span have-experience=\"\">condo claim, please click over to the condo section of our site.</span></p><div class=\"row btn-row\"><div class=\"col-xs-12\"><a class=\"btn btn-afi-cancel\" ui-sref=\"main.report-claim\" role=\"button\">Cancel</a> <button have-experience=\"\" class=\"btn btn-afi pull-right\" alt=\"Log in to file your claim\" type=\"submit\">Log in to file a claim</button></div></div></form>");
$templateCache.put("views/condo-quote-retrieve.html","<form role=\"form\" class=\"afi-form\" name=\"condoQuoteRetrieveForm\" id=\"condoQuoteRetrieveForm\" method=\"post\" novalidate=\"\" ng-submit=\"quoteretrievecondo.submitForm(condoQuoteRetrieveForm)\"><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"hidden-xs\"><span class=\"icon-review quote-icon\"></span>Find your condo quote</h3><p class=\"header-support\">Already started a condo quote? Good move! Find it here in just a few clicks.</p><p class=\"required-text\">All fields required unless otherwise indicated</p></div></div><hr><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : condoQuoteRetrieveForm.$submitted && !condoQuoteRetrieveForm.lastName.$valid}\"><label class=\"control-label\" for=\"lastName\">Last Name</label><div class=\"afi-input\"><input type=\"text\" id=\"lastName\" name=\"lastName\" ng-model=\"quoteretrievecondo.lastName\" class=\"form-control\" ng-pattern=\"/^([a-zA-Z]+[,.]?[ ]?|[a-zA-Z]+[\'-]?)+$/\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"condoQuoteRetrieveForm.lastName.$error\" ng-show=\"condoQuoteRetrieveForm.$submitted &amp;&amp; !quoteretrievehome.lastName.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"pattern\" class=\"ng-scope\">Invalid input</span></span></span></div><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : condoQuoteRetrieveForm.$submitted && !condoQuoteRetrieveForm.email.$valid}\"><label class=\"control-label\" for=\"email\">Email</label><div class=\"afi-input\"><input type=\"email\" id=\"email\" name=\"email\" ng-model=\"quoteretrievecondo.email\" class=\"form-control\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"condoQuoteRetrieveForm.email.$error\" ng-show=\"condoQuoteRetrieveForm.$submitted &amp;&amp; !quoteretrievehome.email.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"email\" class=\"ng-scope\">Invalid input</span></span></span></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : condoQuoteRetrieveForm.$submitted && !condoQuoteRetrieveForm.zipCode.$valid}\"><label class=\"control-label\" for=\"zipCode\">ZIP</label><div class=\"afi-input\"><input type=\"tel\" id=\"zipCode\" name=\"zipCode\" ng-model=\"quoteretrievecondo.retrieveQuoteZip\" class=\"form-control\" ng-pattern=\"/^\\d{5}$/\" maxlength=\"5\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"condoQuoteRetrieveForm.zipCode.$error\" ng-show=\"condoQuoteRetrieveForm.$submitted && !quoteretrievehome.zipCode.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"pattern\" class=\"ng-scope\">Invalid ZIP</span></span></span></div><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : condoQuoteRetrieveForm.$submitted && condoQuoteRetrieveForm.dob.$error.required || condoQuoteRetrieveForm.dob.$error.afValidDob}\"><label class=\"control-label\" for=\"dob\">Date of Birth</label><div class=\"afi-input\"><input id=\"dob\" name=\"dob\" type=\"text\" class=\"form-control\" ng-model=\"quoteretrievecondo.selectedDob\" ui-mask=\"99/99/9999\" model-view-value=\"true\" ui-mask-placeholder=\"__/__/____\" af-min-age=\"14\" af-max-age=\"99\" af-valid-dob=\"\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"condoQuoteRetrieveForm.dob.$error\" role=\"alert\"><span ng-show=\"condoQuoteRetrieveForm.$submitted\" ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"afValidDob\" class=\"ng-scope\">Invalid date of birth</span></span></span></div></div><div class=\"row btn-row\"><div class=\"col-xs-12\"><a class=\"btn btn-afi-cancel\" ui-sref=\"main.quote-retrieve\" role=\"button\">Cancel</a> <button class=\"btn btn-afi pull-right\" type=\"submit\">Find condo quote</button></div></div></form>");
$templateCache.put("views/confirm.html","<div class=\"header landing-header\" id=\"landing-header\"><a id=\"top\" class=\"anchor\"></a><div class=\"navbar navbar-default\" role=\"navigation\"><div class=\"container\"><div class=\"navbar-header\"><a class=\"navbar-brand\" ui-sref=\"main.quote-retrieve\"><img class=\"img-responsive\" src=\"assets/images/logo.png\" alt=\"\"></a></div></div></div></div><div class=\"landing-form-panel\"><div class=\"container\"><div class=\"panel panel-afi confirm-section\"><div class=\"section-content\"><div ui-view=\"\"></div></div></div></div></div>");
$templateCache.put("views/contact.html","<div class=\"row\"><div class=\"col-md-12\"><h3 class=\"hidden-xs\"><span class=\"icon-phone contact-icon\"></span>Questions?</h3><p class=\"header-support\">Our licensed agents are standing by to help!</p></div></div><div class=\"row\"><div class=\"col-sm-4\"><p>Customer Care Center</p><p default-experience=\"\">1-866-328-9577</p><p have-experience=\"\">{{main.brand.connectCusCareNo}}</p><p default-experience=\"\"><a href=\"mailto:contactus@midvaleinsurance.com\">contactus@midvaleinsurance.com</a></p><p have-experience=\"\"><a href=\"mailto:{{main.brand.connectCusCareEmail}}\">{{main.brand.connectCusCareEmail}}</a></p></div><div class=\"col-sm-4\"><p>Hours of Operation:</p><p default-experience=\"\">8 am - 9 pm EST, M-F</p><p have-experience=\"\">{{main.brand.connectCusCareHoursWday}}</p></div></div>");
$templateCache.put("views/generic-claim.html","<form role=\"form\" name=\"generic.claimForm\"><h3><span class=\"icon-quote claim-icon\"></span>Dreams, restored.</h3><p class=\"header-support\">When the unexpected happens, we\'re here every step of the way to help you regroup and restore. To get started on your property claim please contact us at 1-866-328-9577.</p><div class=\"row\"><div class=\"col-xs-12\"><a class=\"btn btn-afi-cancel\" ui-sref=\"main.report-claim\" role=\"button\">Cancel</a></div></div></form>");
$templateCache.put("views/home-claim.html","<form role=\"form\" name=\"home.claimForm\" novalidate=\"\" ng-submit=\"home.submitForm(home.claimForm)\"><h3><span class=\"icon-quote claim-icon\"></span>Dreams, restored.</h3><p class=\"header-support\">When the unexpected happens, we\'re here every step of the way to help you regroup and restore. To get started on your <span default-experience=\"\">property claim please contact us at 1-866-328-9577.</span> <span have-experience=\"\">home claim, please click over to the homeowners section of our site.</span></p><div class=\"row btn-row\"><div class=\"col-xs-12\"><a class=\"btn btn-afi-cancel\" ui-sref=\"main.report-claim\" role=\"button\">Cancel</a> <button have-experience=\"\" class=\"btn btn-afi pull-right\" alt=\"Log in to file your claim\" type=\"submit\">Log in to file a claim</button></div></div></form>");
$templateCache.put("views/home-quote-retrieve.html","<form role=\"form\" name=\"quoteRetrieveHomeForm\" class=\"afi-form\" id=\"quoteRetrieveHomeForm\" method=\"post\" novalidate=\"\" ng-submit=\"quoteretrievehome.submitForm(quoteRetrieveHomeForm)\"><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"hidden-xs\"><span class=\"icon-review quote-icon\"></span>Find your home quote</h3><p class=\"header-support\">Already started a home quote? Good move! Find it here in just a few clicks.</p><p class=\"required-text\">All fields required unless otherwise indicated</p></div></div><hr><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : quoteRetrieveHomeForm.$submitted && !quoteRetrieveHomeForm.lastName.$valid}\"><label class=\"control-label\" for=\"lastName\">Last Name</label><div class=\"afi-input\"><input type=\"text\" id=\"lastName\" name=\"lastName\" ng-model=\"quoteretrievehome.lastName\" class=\"form-control\" ng-pattern=\"/^([a-zA-Z]+[,.]?[ ]?|[a-zA-Z]+[\'-]?)+$/\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"quoteRetrieveHomeForm.lastName.$error\" ng-show=\"quoteRetrieveHomeForm.$submitted &amp;&amp; !quoteretrievehome.lastName.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"pattern\" class=\"ng-scope\">Invalid input</span></span></span></div><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : quoteRetrieveHomeForm.$submitted && !quoteRetrieveHomeForm.email.$valid}\"><label class=\"control-label\" for=\"email\">Email</label><div class=\"afi-input\"><input type=\"email\" id=\"email\" name=\"email\" ng-model=\"quoteretrievehome.email\" class=\"form-control\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"quoteRetrieveHomeForm.email.$error\" ng-show=\"quoteRetrieveHomeForm.$submitted &amp;&amp; !quoteretrievehome.email.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"email\" class=\"ng-scope\">Invalid input</span></span></span></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : quoteRetrieveHomeForm.$submitted && !quoteRetrieveHomeForm.zipCode.$valid}\"><label class=\"control-label\" for=\"zipCode\">ZIP</label><div class=\"afi-input\"><input type=\"tel\" id=\"zipCode\" name=\"zipCode\" ng-model=\"quoteretrievehome.retrieveQuoteZip\" class=\"form-control\" ng-pattern=\"/^\\d{5}$/\" maxlength=\"5\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"quoteRetrieveHomeForm.zipCode.$error\" ng-show=\"quoteRetrieveHomeForm.$submitted && !quoteretrievehome.zipCode.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"pattern\" class=\"ng-scope\">Invalid ZIP</span></span></span></div><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : quoteRetrieveHomeForm.$submitted && quoteRetrieveHomeForm.dob.$error.required || quoteRetrieveHomeForm.dob.$error.afValidDob}\"><label class=\"control-label\" for=\"dob\">Date of Birth</label><div class=\"afi-input\"><input id=\"dob\" name=\"dob\" type=\"text\" class=\"form-control\" ng-model=\"quoteretrievehome.selectedDob\" ui-mask=\"99/99/9999\" model-view-value=\"true\" ui-mask-placeholder=\"__/__/____\" af-min-age=\"14\" af-max-age=\"99\" af-valid-dob=\"\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"quoteRetrieveHomeForm.dob.$error\" role=\"alert\"><span ng-show=\"quoteRetrieveHomeForm.$submitted\" ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"afValidDob\" class=\"ng-scope\">Invalid date of birth</span></span></span></div></div><div class=\"row btn-row\"><div class=\"col-xs-12\"><a class=\"btn btn-afi-cancel\" ui-sref=\"main.quote-retrieve\" role=\"button\">Cancel</a> <button class=\"btn btn-afi pull-right\" type=\"submit\">Find home quote</button></div></div></form>");
$templateCache.put("views/login-form.html","<div><ul class=\"nav navbar-nav navbar hidden-xs\" ng-class=\"!main.mobileMenu\"><li class=\"login-tab\"><a href=\"javascript:void(0)\" ng-click=\"main.offCanvasToggle()\" class=\"ng-click-active\"><span class=\"navbar-left-arrow glyphicon glyphicon-menu-left\"></span> Log In <span class=\"navbar-right-arrow glyphicon glyphicon-menu-right\"></span></a></li></ul><div class=\"panel-body\"><div ng-switch=\"main.policyType.code\"><div ng-switch-when=\"auto\"><p class=\"panel-title\">Manage your auto policy</p><p have-experience=\"\" class=\"panel-text\">Have an auto policy, but no online account?</p><p have-experience=\"\" class=\"panel-text\"><a ng-href=\"{{main.myaccount2016EnrollUrl}}?{{main.params}}\">Sign Up Today!</a></p></div><div ng-switch-default=\"\"><p default-experience=\"\" class=\"panel-title\">Please call 1-866-328-9577 to manage your {{main.policyType.name|lowercase}} policy.</p><p have-experience=\"\" class=\"panel-title\">Manage your {{main.policyType.name|lowercase}} policy</p><p have-experience=\"\" class=\"panel-text\">Need to manage your {{main.policyType.name|lowercase}} policy? We’ll take you there now.</p></div></div><hr><form class=\"afi-form\" name=\"loginForm\" novalidate=\"\"><div class=\"form-group\"><label class=\"control-label\" for=\"policyType\">Policy Type</label><div class=\"afi-input\"><select id=\"policyType\" name=\"policyType\" ng-model=\"main.policyType\" ng-options=\"policy.name for policy in main.claimAndLoginPolicyTypes track by policy.code\" class=\"form-control\" required=\"\" tabindex=\"1\" notify-gtm=\"\"></select><span class=\"underline\"></span></div></div><div ng-switch=\"main.policyType.code\"><div ng-switch-when=\"auto\"><div have-experience=\"\" class=\"panel-actions btn-row\"><a class=\"btn btn-afi-cta\" href=\"{{main.autoMyAccountUrl}}\">Login</a></div></div><div ng-switch-default=\"\"><div have-experience=\"\" class=\"panel-actions btn-row\"><a class=\"btn btn-afi-cta\" href=\"{{main.brand.propertyServiceURL}}\">Login</a></div></div></div></form></div></div>");
$templateCache.put("views/login-slidein-form.html","<nav class=\"hidden-xs\" ng-class=\"!main.viewProperty.device.phone && !$state.includes(\'user-info\') ? \'off-canvas__nav\' : \'hide\'\"><ul class=\"nav navbar-nav navbar hidden-xs\" ng-class=\"!main.mobileMenu\"><li class=\"login-tab\"><a href=\"javascript:void(0)\" ng-click=\"main.offCanvasToggle()\" class=\"ng-click-active\"><span class=\"navbar-left-arrow glyphicon glyphicon-menu-left\"></span> Log In <span class=\"navbar-right-arrow glyphicon glyphicon-menu-right\"></span></a></li></ul><form class=\"afi-form\" name=\"loginForm\" novalidate=\"\"><div class=\"panel-body\"><div ng-switch=\"main.policyType.code\"><div ng-switch-when=\"auto\"><p class=\"panel-title\">Manage your auto policy</p><p have-experience=\"\" class=\"panel-text\">Have an auto policy, but no online account?</p><p have-experience=\"\" class=\"panel-text\"><a ng-href=\"{{main.myaccount2016EnrollUrl}}?{{main.params}}\">Sign Up Today!</a></p></div><div ng-switch-default=\"\"><p default-experience=\"\" class=\"panel-title\">Please call 1-866-328-9577 to manage your {{main.policyType.name|lowercase}} policy.</p><p have-experience=\"\" class=\"panel-title\">Manage your {{main.policyType.name|lowercase}} policy</p><p have-experience=\"\" class=\"panel-text\">Need to manage your {{main.policyType.name|lowercase}} policy? We’ll take you there now.</p></div></div><hr><div class=\"form-group\"><label class=\"control-label\" for=\"policyType\">Policy Type</label><div class=\"afi-input\"><select id=\"policyType\" name=\"policyType\" ng-model=\"main.policyType\" ng-options=\"policy.name for policy in main.claimAndLoginPolicyTypes track by policy.code\" class=\"form-control\" required=\"\" tabindex=\"1\" notify-gtm=\"\"></select><span class=\"underline\"></span></div></div><div ng-switch=\"main.policyType.code\"><div ng-switch-when=\"auto\"><div have-experience=\"\" class=\"btn-row text-center\"><a class=\"btn btn-afi\" alt=\"Log In\" href=\"{{main.autoMyAccountUrl}}\">Log In</a></div></div><div ng-switch-default=\"\"><div have-experience=\"\" class=\"btn-row text-center\"><a class=\"btn btn-afi\" alt=\"Log In\" href=\"{{main.brand.propertyServiceURL}}\">Log In</a></div></div></div></div></form></nav>");
$templateCache.put("views/main.html","<div class=\"off-canvas__content\"><div class=\"header landing-header\" id=\"landing-header\"><a id=\"top\" class=\"anchor\"></a><div class=\"navbar navbar-default\" role=\"navigation\"><div ng-class=\"main.hideBanner && main.viewProperty.device.desktop ? \'container\' : \'container-fluid\'\"><div class=\"navbar-header\"><a class=\"navbar-brand\" ng-click=\"main.hideBanner=!main.hideBanner\"><span default-experience=\"\"><img class=\"img-responsive\" src=\"assets/images/logo.png\" alt=\"\"></span> <span have-experience=\"\"><img class=\"img-responsive\" ng-src=\"{{main.brand.headerLogoPath}}\" alt=\"\"></span></a></div></div></div></div><div class=\"landing-banner animated\" ng-hide=\"main.hideBanner && !main.viewProperty.device.phone\"><div class=\"container\"><div class=\"welcome-text-container\"><div class=\"welcome-text\"><h1 class=\"heading\">LET\'S CONNECT</h1></div></div></div><div class=\"landing-greeting\"><div class=\"container\"><p class=\"copy\">Welcome to <span default-experience=\"\">Midvale Insurance Program</span> <span have-experience=\"\">{{ main.brand.company }}</span> — where you can manage your policy online. Because we believe the hard work you put into achieving your dreams deserves to be protected.</p></div></div></div><div class=\"landing-secondary-header hidden-xs\"><div class=\"navbar-secondary\" role=\"navigation\"><div class=\"container\"><ul class=\"nav navbar-nav navbar-secondary-container\"><li ng-class=\"{\'active\': $state.is(\'main.quote-retrieve\') || $state.is(\'main.quote-retrieve.auto\') || $state.is(\'main.quote-retrieve.home\') || $state.is(\'main.quote-retrieve.renters\') || $state.is(\'main.quote-retrieve.commercial\') || $state.is(\'main.quote-retrieve.condo\') || $state.is(\'main.login\') }\" ng-click=\"main.offCanvasClose();$state.go(\'main.quote-retrieve\');main.hideBanner = true;\"><a href=\"javascript:void(0)\">Retrieve Your Quote</a></li><li ng-class=\"{\'active\': $state.is(\'main.report-claim\') || $state.is(\'main.report-claim.auto\') || $state.is(\'main.report-claim.home\') || $state.is(\'main.report-claim.renters\') || $state.is(\'main.report-claim.condo\') }\" ng-click=\"main.offCanvasClose();$state.go(\'main.report-claim\');main.hideBanner = true;\"><a href=\"javascript:void(0)\">File a Claim</a></li><li ng-class=\"{\'active\': $state.is(\'main.contact\')}\" ng-click=\"main.offCanvasClose();$state.go(\'main.contact\');main.hideBanner = true;\"><a href=\"javascript:void(0)\">Contact Us</a></li></ul></div></div></div><div class=\"landing-form-panel\" ng-class=\"{\'hidden-xs\': $state.current.data.mobileMenu === true}\"><div class=\"container\"><div class=\"panel panel-afi claim-section\"><div class=\"section-content\"><div ui-view=\"desktop\"></div></div></div></div></div></div><div class=\"landing-mobile-panel visible-xs\"><div class=\"container\"><div class=\"afi-accordion\" uib-accordion=\'close-others=\"false\"\'><div uib-accordion-group=\"\" class=\"afi-accordion-group\" is-open=\"$state.is(\'main.login\')\" is-disabled=\"true\"><div uib-accordion-heading=\"\"><div class=\"accordion-heading\" ng-click=\"$state.go(\'main.login\')\"><span>Log In</span> <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-triangle-bottom\': $state.is(\'main.login\'), \'glyphicon-triangle-right\': !$state.is(\'main.login\')}\"></i></div></div><div class=\"panel-afi login-panel\" ng-show=\"$state.is(\'main.login\')\" ng-class=\"\'enter-fadeIn exit-fadeOut speed-400 stagger-100\'\"><div ui-view=\"mobile-login\"></div></div></div><div uib-accordion-group=\"\" class=\"afi-accordion-group\" is-open=\"$state.is(\'main.quote-retrieve\') || $state.is(\'main.quote-retrieve.auto\') || $state.is(\'main.quote-retrieve.home\') || $state.is(\'main.quote-retrieve.renters\') || $state.is(\'main.quote-retrieve.commercial\') || $state.is(\'main.quote-retrieve.condo\')\" is-disabled=\"true\"><div uib-accordion-heading=\"\"><div class=\"accordion-heading\" ng-click=\"$state.go(\'main.quote-retrieve\')\"><span>Retrieve a quote</span> <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-triangle-bottom\': $state.is(\'main.quote-retrieve\') || $state.is(\'main.quote-retrieve.auto\') || $state.is(\'main.quote-retrieve.home\') || $state.is(\'main.quote-retrieve.renters\') || $state.is(\'main.quote-retrieve.commercial\') || $state.is(\'main.quote-retrieve.condo\') , \'glyphicon-triangle-right\': !$state.is(\'main.quote-retrieve\') || !$state.is(\'main.quote-retrieve.auto\') || !$state.is(\'main.quote-retrieve.home\') || !$state.is(\'main.quote-retrieve.renters\') || !$state.is(\'main.quote-retrieve.commercial\') || !$state.is(\'main.quote-retrieve.condo\') }\"></i></div></div><div class=\"panel-afi retrieve-panel\" ng-show=\"$state.is(\'main.quote-retrieve\') || $state.is(\'main.quote-retrieve.auto\') || $state.is(\'main.quote-retrieve.home\') || $state.is(\'main.quote-retrieve.renters\') || $state.is(\'main.quote-retrieve.commercial\') || $state.is(\'main.quote-retrieve.condo\')\" ng-class=\"\'enter-fadeIn exit-fadeOut speed-400 stagger-100\'\"><div ui-view=\"mobile-quote\"></div></div></div><div uib-accordion-group=\"\" class=\"afi-accordion-group\" is-open=\"$state.is(\'main.report-claim\') || $state.is(\'main.report-claim.auto\') || $state.is(\'main.report-claim.home\') || $state.is(\'main.report-claim.renters\') || $state.is(\'main.report-claim.condo\')\" is-disabled=\"true\"><div uib-accordion-heading=\"\"><div class=\"accordion-heading\" ng-click=\"$state.go(\'main.report-claim\');\"><span>File a claim</span> <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-triangle-bottom\': $state.is(\'main.report-claim\') || $state.is(\'main.report-claim.auto\') || $state.is(\'main.report-claim.home\') || $state.is(\'main.report-claim.renters\') || $state.is(\'main.report-claim.condo\') , \'glyphicon-triangle-right\': !$state.is(\'main.report-claim\') || !$state.is(\'main.report-claim.auto\') || !$state.is(\'main.report-claim.home\') || !$state.is(\'main.report-claim.renters\') || !$state.is(\'main.report-claim.condo\') }\"></i></div></div><div class=\"panel-afi claim-panel\" ng-show=\"$state.is(\'main.report-claim\') || $state.is(\'main.report-claim.auto\') || $state.is(\'main.report-claim.home\') || $state.is(\'main.report-claim.renters\') || $state.is(\'main.report-claim.condo\')\" ng-class=\"\'enter-fadeIn exit-fadeOut speed-400 stagger-100\'\"><div ui-view=\"mobile-claim\"></div></div></div><div uib-accordion-group=\"\" class=\"afi-accordion-group\" is-open=\"$state.is(\'main.contact\')\" is-disabled=\"true\"><div uib-accordion-heading=\"\"><div class=\"accordion-heading\" ng-click=\"$state.go(\'main.contact\')\"><span>Contact</span> <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-triangle-bottom\': $state.is(\'main.contact\'), \'glyphicon-triangle-right\': !$state.is(\'main.contact\')}\"></i></div></div><div class=\"panel-afi contact-panel\" ng-show=\"$state.is(\'main.contact\')\" ng-class=\"\'enter-fadeIn exit-fadeOut speed-400 stagger-100\'\"><div ui-view=\"mobile-contact\"></div></div></div></div></div></div><div class=\"footer landing-footer\"><div class=\"container\"><div class=\"vertical-align\"><div class=\"footer-logo\"><span default-experience=\"\"><img class=\"img-responsive\" src=\"assets/images/footer-logo.png\" alt=\"\"></span> <span have-experience=\"\"><img class=\"img-responsive\" ng-src=\"{{main.brand.footerLogoPath}}\" alt=\"\"></span></div><div class=\"footer-info\"><ul><li><a target=\"_blank\" ng-href=\"{{main.footerUrl}}/Midvale-Texting-Terms-and-Conditions\">Text Messaging Program</a></li><li><a target=\"_blank\" ng-href=\"{{main.footerUrl}}/companyId-midvale\">Company Identification</a></li><li><a target=\"_blank\" href=\"https://go.homesite.com/privacy-policy.html\">Privacy and Security Policy</a></li><li><a target=\"_blank\" ng-href=\"{{main.footerUrl}}/legal-midvale\">Legal Notice</a></li><li><a target=\"_blank\" href=\"https://www.amfam.com/~/media/Sales/CreditScoring/012361_CreditScore\">Credit-Based Insurance Scoring (PDF)</a></li></ul></div></div></div></div>");
$templateCache.put("views/quote-retrieve.html","<div><form class=\"afi-form\" role=\"form\" name=\"selectForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"hidden-xs\"><span class=\"icon-review quote-icon\"></span>Finish what you started</h3><p class=\"header-support\">Already have a quote started here? Smart move! Peace of mind is just a <span ng-if=\"main.brand.retrieveQuoteEnabled\">few more clicks</span><span ng-if=\"!main.brand.retrieveQuoteEnabled\">phone call</span> away.</p><p ng-if=\"!main.brand.retrieveQuoteEnabled\" class=\"header-support\">Contact our Care Center, {{main.brand.connectCusCareNo}}, for assistance.</p><p ng-if=\"main.brand.retrieveQuoteEnabled\" class=\"required-text\">All fields required unless otherwise indicated</p></div></div><div ng-if=\"main.brand.retrieveQuoteEnabled\"><hr><div class=\"row\"><div class=\"form-group col-md-6\" ng-class=\"{ \'has-error\' : selectForm.$submitted && !selectForm.policyType.$valid}\"><label class=\"control-label\" for=\"quotePolicyType\">What’s your quote type?</label> <span class=\"input-field-note control-label\" ng-messages=\"selectForm.state.$error\" ng-show=\"selectForm.$submitted && !selectForm.policyType.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">(required input)</span></span><div class=\"afi-input\"><select id=\"quotePolicyType\" name=\"quotePolicyType\" ng-model=\"quoteretrieve.policyType\" ng-options=\"policy.name for policy in main.quotePolicyTypes track by policy.code\" ng-change=\"quoteretrieve.submitForm(selectForm);main.hideBanner = true\" class=\"form-control\" required=\"\" notify-gtm=\"\"><option value=\"\" selected=\"selected\">Select</option></select><span class=\"underline\"></span></div></div></div></div></form></div>");
$templateCache.put("views/renters-claim.html","<form role=\"form\" name=\"renters.claimForm\" novalidate=\"\" ng-submit=\"renters.submitForm(renters.claimForm)\"><h3><span class=\"icon-quote claim-icon\"></span>Dreams, restored.</h3><p class=\"header-support\">When the unexpected happens, we\'re here every step of the way to help you regroup and restore. To get started on your <span default-experience=\"\">property claim please contact us at 1-866-328-9577.</span> <span have-experience=\"\">renters claim, please click over to the renters section of our site.</span></p><div class=\"row\"><div class=\"col-xs-12\"><a class=\"btn btn-afi-cancel\" ui-sref=\"main.report-claim\" role=\"button\">Cancel</a> <button have-experience=\"\" class=\"btn btn-afi pull-right\" alt=\"Log in to file your claim\" type=\"submit\">Log in to file a claim</button></div></div></form>");
$templateCache.put("views/renters-quote-retrieve.html","<form role=\"form\" class=\"afi-form\" name=\"rentersQuoteRetrieveForm\" id=\"rentersQuoteRetrieveForm\" method=\"post\" novalidate=\"\" ng-submit=\"quoteretrieverenters.submitForm(rentersQuoteRetrieveForm)\"><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"hidden-xs\"><span class=\"icon-review quote-icon\"></span>Find your renters quote</h3><p class=\"header-support\">Already started a renters quote? Good move! Find it here in just a few clicks.</p><p class=\"required-text\">All fields required unless otherwise indicated</p></div></div><hr><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : rentersQuoteRetrieveForm.$submitted && !rentersQuoteRetrieveForm.lastName.$valid}\"><label class=\"control-label\" for=\"lastName\">Last Name</label><div class=\"afi-input\"><input type=\"text\" id=\"lastName\" name=\"lastName\" ng-model=\"quoteretrieverenters.lastName\" class=\"form-control\" ng-pattern=\"/^([a-zA-Z]+[,.]?[ ]?|[a-zA-Z]+[\'-]?)+$/\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"rentersQuoteRetrieveForm.lastName.$error\" ng-show=\"rentersQuoteRetrieveForm.$submitted &amp;&amp; !quoteretrievehome.lastName.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"pattern\" class=\"ng-scope\">Invalid input</span></span></span></div><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : rentersQuoteRetrieveForm.$submitted && !rentersQuoteRetrieveForm.email.$valid}\"><label class=\"control-label\" for=\"email\">Email</label><div class=\"afi-input\"><input type=\"email\" id=\"email\" name=\"email\" ng-model=\"quoteretrieverenters.email\" class=\"form-control\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"rentersQuoteRetrieveForm.email.$error\" ng-show=\"rentersQuoteRetrieveForm.$submitted &amp;&amp; !quoteretrievehome.email.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"email\" class=\"ng-scope\">Invalid input</span></span></span></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : rentersQuoteRetrieveForm.$submitted && !rentersQuoteRetrieveForm.zipCode.$valid}\"><label class=\"control-label\" for=\"zipCode\">ZIP</label><div class=\"afi-input\"><input type=\"tel\" id=\"zipCode\" name=\"zipCode\" ng-model=\"quoteretrieverenters.retrieveQuoteZip\" class=\"form-control\" ng-pattern=\"/^\\d{5}$/\" maxlength=\"5\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"rentersQuoteRetrieveForm.zipCode.$error\" ng-show=\"rentersQuoteRetrieveForm.$submitted && !quoteretrievehome.zipCode.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"pattern\" class=\"ng-scope\">Invalid ZIP</span></span></span></div><div class=\"form-group col-xs-12 col-sm-6\" ng-class=\"{ \'has-error\' : rentersQuoteRetrieveForm.$submitted && rentersQuoteRetrieveForm.dob.$error.required || rentersQuoteRetrieveForm.dob.$error.afValidDob}\"><label class=\"control-label\" for=\"dob\">Date of Birth</label><div class=\"afi-input\"><input id=\"dob\" name=\"dob\" type=\"text\" class=\"form-control\" ng-model=\"quoteretrieverenters.selectedDob\" ui-mask=\"99/99/9999\" model-view-value=\"true\" ui-mask-placeholder=\"__/__/____\" af-min-age=\"14\" af-max-age=\"99\" af-valid-dob=\"\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"rentersQuoteRetrieveForm.dob.$error\" role=\"alert\"><span ng-show=\"rentersQuoteRetrieveForm.$submitted\" ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"afValidDob\" class=\"ng-scope\">Invalid date of birth</span></span></span></div></div><div class=\"row btn-row\"><div class=\"col-xs-12\"><a class=\"btn btn-afi-cancel\" ui-sref=\"main.quote-retrieve\" role=\"button\">Cancel</a> <button class=\"btn btn-afi pull-right\" type=\"submit\">Find renters quote</button></div></div></form>");
$templateCache.put("views/report-claim.html","<div><form ng-show=\"$state.current.url === \'report-claim\'\" class=\"afi-form\" role=\"form\" action=\"post\" name=\"rc.selectForm\" novalidate=\"\"><h3 class=\"hidden-xs\"><span class=\"icon-quote claim-icon\"></span>Dreams, restored.</h3><p class=\"header-support\">When the unexpected happens, we\'re here every step of the way to help you regroup and restore. To get a claim started select the claim type below.</p><p class=\"required-text\">All fields required unless otherwise indicated</p><hr><div class=\"row\"><div class=\"form-group col-md-6\" ng-class=\"{ \'has-error\' : rc.selectForm.$submitted && !rc.selectForm.policyType.$valid}\"><label class=\"control-label\" for=\"policyType\">What\'s your claim type?</label><div class=\"afi-input\"><select id=\"policyType\" name=\"policyType\" ng-model=\"rc.policyType\" ng-options=\"policy.name for policy in main.claimAndLoginPolicyTypes track by policy.code\" ng-change=\"rc.submitForm()\" class=\"form-control\" required=\"\" notify-gtm=\"\"><option value=\"\" selected=\"selected\">Select</option></select><span class=\"underline\"></span></div><div ng-messages=\"rc.selectForm.state.$error\" ng-show=\"rc.selectForm.$submitted &amp;&amp; !rc.policyType.$valid\" role=\"alert\" class=\"help-block ng-active ng-hide\"><div ng-message=\"required\" class=\"ng-scope\">Select a claim type</div></div></div></div></form><div ui-view=\"\"></div></div>");
$templateCache.put("views/test-states.html","<div class=\"row\"><div class=\"col-md-12\"><h1 style=\"margin: 0 0 20px 0;\">Testing</h1></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Routes</h3></div><div class=\"panel-body\"><h4>Main</h4><ul><li><a href=\"#\" ui-sref=\"main\">Main (not working - should redirect to /quote-retrieve)</a></li><li><a href=\"#\" ui-sref=\"main.login\">Login (mobile = show login accordion / desktop = show slide-in menu)</a></li></ul><hr><h4>Retrieve a quote</h4><ul><li><a href=\"#\" ui-sref=\"main.quote-retrieve\">Retrieve a quote selection</a></li><li><a href=\"#\" ui-sref=\"main.quote-retrieve.auto\">Retrieve an auto quote</a></li><li><a href=\"#\" ui-sref=\"main.quote-retrieve.condo\">Retrieve a condo quote</a></li><li><a href=\"#\" ui-sref=\"main.quote-retrieve.home\">Retrieve a home quote</a></li><li><a href=\"#\" ui-sref=\"main.quote-retrieve.renters\">Retrieve a renters quote</a></li></ul><hr><h4>Report a claim</h4><ul><li><a href=\"#\" ui-sref=\"main.report-claim\">Report a claim selection</a></li><li><a href=\"#\" ui-sref=\"main.report-claim.auto\">Report an auto claim</a></li><li><a href=\"#\" ui-sref=\"main.report-claim.condo\">Report a condo claim</a></li><li><a href=\"#\" ui-sref=\"main.report-claim.home\">Report a home claim</a></li><li><a href=\"#\" ui-sref=\"main.report-claim.renters\">Report a renters claim</a></li></ul><hr><a href=\"#\" ui-sref=\"main.contact\">Contact info</a><hr><a href=\"#\" ui-sref=\"confirm.auto-claim\">Auto claim confirmation (Won\'t load an actual claim number)</a><hr><h4>Interstitial</h4><ul><li>---- Not provided ---</li><li><a href=\"#\" ui-sref=\"user-info.zip-needed\">Interstitial - No zip</a></li><li>---- Auto ---</li><li><a href=\"#\" ui-sref=\"user-info.auto-zip-needed\">Interstitial - Auto Zip Needed</a></li><li><a href=\"#\" ui-sref=\"user-info.auto-nozip\">Interstitial - Auto No Zip</a></li><li><a href=\"#\" ui-sref=\"user-info.auto-invalidstate\">Interstitial - Auto Invalid State</a></li><li>---- Condo ---</li><li><a href=\"#\" ui-sref=\"user-info.condo-zip-needed\">Interstitial - Condo Zip Needed</a></li><li><a href=\"#\" ui-sref=\"user-info.condo-nozip\">Interstitial - Condo No Zip</a></li><li><a href=\"#\" ui-sref=\"user-info.condo-invalidstate\">Interstitial - Condo Invalid State</a></li><li>---- Home ---</li><li><a href=\"#\" ui-sref=\"user-info.home-zip-needed\">Interstitial - Home Zip Needed</a></li><li><a href=\"#\" ui-sref=\"user-info.home-nozip\">Interstitial - Home No Zip</a></li><li><a href=\"#\" ui-sref=\"user-info.home-invalidstate\">Interstitial - Home Invalid State</a></li><li>---- Renters ---</li><li><a href=\"#\" ui-sref=\"user-info.renters-zip-needed\">Interstitial - Renters Zip Needed</a></li><li><a href=\"#\" ui-sref=\"user-info.renters-nozip\">Interstitial - Renters No Zip</a></li><li><a href=\"#\" ui-sref=\"user-info.renters-invalidstate\">Interstitial - Renters Invalid State</a></li></ul><hr><a href=\"#\" ui-sref=\"user-info.test\">This page</a></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Date / Time / DOB Test</h3></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><h4>Claims - Date Time Format Checks</h4></div><div class=\"col-md-6\" ng-class=\"{ \'has-error\' : claimTimeForm.$submitted && claimTimeForm.incidentTime.$invalid}\"><form class=\"afi-form\" role=\"form\" name=\"claimTimeForm\" novalidate=\"\" ng-submit=\"claim.checkTime(claimTimeForm)\"><label class=\"control-label\" for=\"incidentTime\">Time of Incident</label> <span class=\"input-field-note control-label\" ng-messages=\"claimTimeForm.incidentTime.$error\" ng-show=\"claimTimeForm.$submitted && !quoteretrieveaincidentTto.incidentTime.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">(required input)</span> <span ng-message=\"date\" class=\"ng-scope\">(invalid date)</span></span><div class=\"input-group afi-timepicker\"><div class=\"afi-input\"><input type=\"text\" class=\"form-control\" placeholder=\"HH:MM PM\" size=\"8\" ng-model=\"claim.incidentTime\" id=\"incidentTime\" name=\"incidentTime\" bs-timepicker=\"\" minute-step=\"1\" use-native=\"true\" time-format=\"hh:mm a\" show-meridian=\"true\" autoclose=\"1\" length=\"7\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-group-btn hidden-sm hidden-xs\"><label class=\"btn btn-default\" for=\"incidentTime\"><i class=\"glyphicon glyphicon-time\"></i></label></span></div><button class=\"btn btn-afi\" type=\"submit\">Test Time (Check console)</button></form></div><div class=\"col-md-6\"><form class=\"afi-form\" role=\"form\" name=\"claimDateForm\" novalidate=\"\" ng-submit=\"claim.checkDate(claimDateForm)\"><label class=\"control-label\" for=\"incidentDate\">Date of Incident</label> <span class=\"input-field-note control-label\" ng-messages=\"claimDateForm.incidentDate.$error\" ng-show=\"claimDateForm.$submitted && !claimDateForm.incidentDate.$valid\" role=\"alert\"><span ng-message=\"required\" class=\"ng-scope\">(required input)</span> <span ng-message=\"incidentDate\" class=\"ng-scope\">(invalid date)</span></span><div class=\"input-group afi-datepicker\"><div class=\"afi-input\"><input type=\"text\" class=\"form-control\" ng-model=\"claim.incidentDate\" placeholder=\"MM/DD/YYYY\" id=\"incidentDate\" name=\"incidentDate\" bs-datepicker=\"\" autoclose=\"true\" max-date=\"today\" date-format=\"MM/dd/yyyy\" use-native=\"true\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-group-btn hidden-sm hidden-xs\"><label class=\"btn btn-default\" for=\"incidentDate\"><i class=\"glyphicon glyphicon-calendar\"></i></label></span></div><button class=\"btn btn-afi\" type=\"submit\">Test Date (Check console)</button></form></div></div><hr><div class=\"row\"><div class=\"col-md-6\"><form class=\"afi-form\" role=\"form\" name=\"quoteRetrieveAutoForm\" novalidate=\"\" ng-submit=\"claim.checkDob(quoteRetrieveAutoForm)\"><div class=\"col-md-12\"><h4>Retrieve Auto Quote DOB Format Check</h4></div><div class=\"col-md-12\"><div class=\"row\"><div class=\"form-group col-md-12\" ng-class=\"{ \'has-error\' : quoteRetrieveAutoForm.$submitted && quoteRetrieveAutoForm.dob.$error.required || quoteRetrieveAutoForm.dob.$error.afValidDob}\"><label class=\"control-label\" for=\"dob\">Date of Birth</label><div class=\"afi-input\"><input id=\"dob\" name=\"dob\" type=\"text\" class=\"form-control\" ng-model=\"claim.selectedDob\" ui-mask=\"99/99/9999\" model-view-value=\"true\" ui-mask-placeholder=\"__/__/____\" af-min-age=\"14\" af-max-age=\"99\" af-valid-dob=\"\" required=\"\"> <span class=\"underline\"></span></div><span class=\"input-field-note control-label\"><span class=\"input-field-error\" ng-messages=\"quoteRetrieveAutoForm.dob.$error\" role=\"alert\"><span ng-show=\"quoteRetrieveAutoForm.$submitted\" ng-message=\"required\" class=\"ng-scope\">Required input</span> <span ng-message=\"afValidDob\" class=\"ng-scope\">Invalid date of birth</span></span></span></div><div class=\"form-group col-md-6\"><button class=\"btn btn-afi\" type=\"submit\">Test DOB (Check console)</button></div></div></div></form></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Chat Live Test (Chat cannot be initiated here)</h3></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-xs-12\" ng-class=\"claim.chat.active ? \'col-sm-8\' : \'col-sm-12\'\"><h3 class=\"hidden-xs\"><span class=\"icon-quote claim-icon\"></span>Dreams, restored.</h3><p>When the unexpected happens, we\'re here every step of the way to help you regroup and restore. To get your auto claim started just fill out this form. We\'ll take it from here.</p><p class=\"header-support\">For immediate assistance, please call us at: {{main.brand.connectClaimNo}}</p><p class=\"required-text\">All fields required unless otherwise indicated</p></div><div class=\"col-xs-12 col-sm-4\" ng-show=\"claim.chat.active\"><div class=\"afi-well\"><h4><span class=\"icon-chat\"></span>Do you need some help?</h4><p>For auto claims questions, chat online with a customer care representative.</p><div class=\"btn-row\"><a class=\"btn btn-block btn-afi-secondary\" href=\"javascript:void(0);\" ng-click=\"claim.chatInfoModal()\" role=\"button\">Chat with us online</a></div></div></div></div></div></div>");
$templateCache.put("views/user-info.html","<div class=\"header landing-header interstitial\" id=\"landing-header\"><a id=\"top\" class=\"anchor\"></a><div class=\"navbar navbar-default\" role=\"navigation\"><div class=\"container\"><div class=\"col-xs-7\"><div class=\"navbar-header\"><a href=\"javascript:void(0);\" class=\"navbar-brand\"><img class=\"img-responsive\" src=\"assets/images/logo.png\" alt=\"\"></a></div></div><div class=\"col-xs-5\"><a ng-show=\"$state.current.data.branded === true\" href=\"javascript:void(0);\" class=\"navbar-brand navbar-right pull-right\"><img class=\"img-responsive\" src=\"assets/images/wf-incidental.png\"></a></div></div></div></div><div class=\"landing-form-panel\"><div class=\"container\"><div class=\"panel panel-afi zip-needed-section\" ng-class=\"{\'hidden-xs\': $state.current.data.mobileMenu === true}\"><div class=\"section-content\"><div ui-view=\"\"></div></div></div></div></div>");}]);